window.DDQ_ORIGINAL_PROFILES = [
  {
    "id": "nasomatto-duro",
    "brand": "Nasomatto",
    "name": "Duro",
    "variant": "",
    "searchTerms": [
      "Duro",
      "Nasomatto Duro",
      "E-59",
      "E59"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "würzig"
    ],
    "directionTerms": [
      "holzig",
      "würzig"
    ],
    "directProductTerms": [
      "Duro",
      "E-59",
      "E59",
      "e-59-duro"
    ],
    "shopHandle": "e-59-duro",
    "handle": "e-59-duro",
    "shopCode": "E-59",
    "shopProduct": "Duro",
    "productUrl": "https://dieduftquelle.com/products/e-59-duro",
    "confidence": 100,
    "direction": "holzig - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "atkinsons-oud-save-the-king",
    "brand": "Atkinsons",
    "name": "Oud Save the King",
    "variant": "",
    "searchTerms": [
      "Oud Save the King",
      "Atkinsons Oud Save the King",
      "E-103 - Oud Kings",
      "E-103",
      "E103",
      "Oud Kings"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "süß"
    ],
    "directionTerms": [
      "holzig",
      "süß"
    ],
    "directProductTerms": [
      "E-103 - Oud Kings",
      "E-103",
      "E103",
      "e-103-alternative-zu-oud-save-the-king"
    ],
    "shopHandle": "e-103-alternative-zu-oud-save-the-king",
    "handle": "e-103-alternative-zu-oud-save-the-king",
    "shopCode": "E-103",
    "shopProduct": "E-103 - Oud Kings",
    "productUrl": "https://dieduftquelle.com/products/e-103-alternative-zu-oud-save-the-king",
    "confidence": 100,
    "direction": "holzig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-erba-pura",
    "brand": "Xerjoff",
    "name": "Erba Pura",
    "variant": "",
    "searchTerms": [
      "Erba Pura",
      "Xerjoff Erba Pura",
      "E-16 - E. Pura",
      "E-16",
      "E16",
      "XJ Erba Pura",
      "E. Pura"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "süß"
    ],
    "directionTerms": [
      "fruchtig",
      "süß"
    ],
    "directProductTerms": [
      "E-16 - E. Pura",
      "E-16",
      "E16",
      "e-16-pura"
    ],
    "shopHandle": "e-16-pura",
    "handle": "e-16-pura",
    "shopCode": "E-16",
    "shopProduct": "E-16 - E. Pura",
    "productUrl": "https://dieduftquelle.com/products/e-16-pura",
    "confidence": 100,
    "direction": "fruchtig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "maison-francis-kurkdjian-baccarat-rouge-540",
    "brand": "Maison Francis Kurkdjian",
    "name": "Baccarat Rouge 540",
    "variant": "",
    "searchTerms": [
      "Baccarat Rouge 540",
      "Maison Francis Kurkdjian Baccarat Rouge 540",
      "E-3 - Bacra",
      "E-3",
      "E3",
      "Baccarat",
      "Baccarat Rouge",
      "BR540",
      "MFK Baccarat",
      "MFK Baccarat Rouge 540",
      "Francis Kurkdjian Baccarat Rouge 540",
      "BR 540",
      "Bacra",
      "Rouge"
    ],
    "notes": [],
    "accords": [
      "süß",
      "holzig"
    ],
    "directionTerms": [
      "süß",
      "holzig"
    ],
    "directProductTerms": [
      "E-3 - Bacra",
      "E-3",
      "E3",
      "e-3-alternative-zu-baccarat"
    ],
    "shopHandle": "e-3-alternative-zu-baccarat",
    "handle": "e-3-alternative-zu-baccarat",
    "shopCode": "E-3",
    "shopProduct": "E-3 - Bacra",
    "productUrl": "https://dieduftquelle.com/products/e-3-alternative-zu-baccarat",
    "confidence": 100,
    "direction": "süß - holzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "serge-lutens-ambre-sultan",
    "brand": "Serge Lutens",
    "name": "Ambre Sultan",
    "variant": "",
    "searchTerms": [
      "Ambre Sultan",
      "Serge Lutens Ambre Sultan",
      "E-6 - Ambre Sultan",
      "E-6",
      "E6",
      "Serge Luten Ambre Sultan",
      "Ambre",
      "Sultan"
    ],
    "notes": [],
    "accords": [
      "orientalisch",
      "würzig"
    ],
    "directionTerms": [
      "orientalisch",
      "würzig"
    ],
    "directProductTerms": [
      "E-6 - Ambre Sultan",
      "E-6",
      "E6",
      "ambre-sultan"
    ],
    "shopHandle": "ambre-sultan",
    "handle": "ambre-sultan",
    "shopCode": "E-6",
    "shopProduct": "E-6 - Ambre Sultan",
    "productUrl": "https://dieduftquelle.com/products/ambre-sultan",
    "confidence": 100,
    "direction": "orientalisch - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "parfums-de-marly-perseus",
    "brand": "Parfums de Marly",
    "name": "Perseus",
    "variant": "",
    "searchTerms": [
      "Perseus",
      "Parfums de Marly Perseus",
      "L-25 - Perseus",
      "L-25",
      "L25",
      "PDM Perseus",
      "Parfum de Marly Perseus"
    ],
    "notes": [],
    "accords": [
      "Zitrus",
      "frisch"
    ],
    "directionTerms": [
      "Zitrus",
      "frisch"
    ],
    "directProductTerms": [
      "L-25 - Perseus",
      "L-25",
      "L25",
      "perseus"
    ],
    "shopHandle": "perseus",
    "handle": "perseus",
    "shopCode": "L-25",
    "shopProduct": "L-25 - Perseus",
    "productUrl": "https://dieduftquelle.com/products/perseus",
    "confidence": 100,
    "direction": "Zitrus - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "le-labo-santal-33",
    "brand": "Le Labo",
    "name": "Santal 33",
    "variant": "",
    "searchTerms": [
      "Santal 33",
      "Le Labo Santal 33",
      "L-45 Santal 33",
      "L-45",
      "L45",
      "Santal"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "würzig"
    ],
    "directionTerms": [
      "holzig",
      "würzig"
    ],
    "directProductTerms": [
      "L-45 Santal 33",
      "L-45",
      "L45",
      "l-45-santal-3-3"
    ],
    "shopHandle": "l-45-santal-3-3",
    "handle": "l-45-santal-3-3",
    "shopCode": "L-45",
    "shopProduct": "L-45 Santal 33",
    "productUrl": "https://dieduftquelle.com/products/l-45-santal-3-3",
    "confidence": 100,
    "direction": "holzig - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "essential-parfums-bois-imperial",
    "brand": "Essential Parfums",
    "name": "Bois Impérial",
    "variant": "",
    "searchTerms": [
      "Bois Impérial",
      "Essential Parfums Bois Impérial",
      "L-50 Bois Imperiale",
      "L-50",
      "L50",
      "Essential Parfum Bois Impérial",
      "Bois Imperial",
      "Essential Parfums Bois Imperial",
      "Essential Parfum Bois Imperial",
      "Bois Imperiale",
      "Impérial"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "holzig"
    ],
    "directionTerms": [
      "frisch",
      "holzig"
    ],
    "directProductTerms": [
      "L-50 Bois Imperiale",
      "L-50",
      "L50",
      "l-50-bois-imperiale"
    ],
    "shopHandle": "l-50-bois-imperiale",
    "handle": "l-50-bois-imperiale",
    "shopCode": "L-50",
    "shopProduct": "L-50 Bois Imperiale",
    "productUrl": "https://dieduftquelle.com/products/l-50-bois-imperiale",
    "confidence": 100,
    "direction": "frisch - holzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "escentric-molecules-molecule-01",
    "brand": "Escentric Molecules",
    "name": "Molecule 01",
    "variant": "",
    "searchTerms": [
      "Molecule 01",
      "Escentric Molecules Molecule 01",
      "MOLE1",
      "Molecule",
      "L-43",
      "L43"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "syntetisch"
    ],
    "directionTerms": [
      "holzig",
      "syntetisch"
    ],
    "directProductTerms": [
      "MOLE1",
      "L-43",
      "L43",
      "molecule-01"
    ],
    "shopHandle": "molecule-01",
    "handle": "molecule-01",
    "shopCode": "L-43",
    "shopProduct": "MOLE1",
    "productUrl": "https://dieduftquelle.com/products/molecule-01",
    "confidence": 100,
    "direction": "holzig - syntetisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-naxos",
    "brand": "Xerjoff",
    "name": "Naxos",
    "variant": "",
    "searchTerms": [
      "Naxos",
      "Xerjoff Naxos",
      "Nax",
      "XJ Naxos",
      "E-34",
      "E34"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "Nax",
      "E-34",
      "E34",
      "e-34-alternative-zu-naxos"
    ],
    "shopHandle": "e-34-alternative-zu-naxos",
    "handle": "e-34-alternative-zu-naxos",
    "shopCode": "E-34",
    "shopProduct": "Nax",
    "productUrl": "https://dieduftquelle.com/products/e-34-alternative-zu-naxos",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dior-sauvage",
    "brand": "Dior",
    "name": "Sauvage",
    "variant": "",
    "searchTerms": [
      "Sauvage",
      "Dior Sauvage",
      "Solvag",
      "E-37",
      "E37"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "würzig"
    ],
    "directionTerms": [
      "frisch",
      "würzig"
    ],
    "directProductTerms": [
      "Solvag",
      "E-37",
      "E37",
      "e-37-sau_vage"
    ],
    "shopHandle": "e-37-sau_vage",
    "handle": "e-37-sau_vage",
    "shopCode": "E-37",
    "shopProduct": "Solvag",
    "productUrl": "https://dieduftquelle.com/products/e-37-sau_vage",
    "confidence": 100,
    "direction": "frisch - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dior-sauvage-elixir",
    "brand": "Dior",
    "name": "Sauvage Elixir",
    "variant": "",
    "searchTerms": [
      "Sauvage Elixir",
      "Dior Sauvage Elixir",
      "Solvag Elixiiir",
      "Solvag Elixir",
      "Sauvage",
      "Elixir",
      "E-96",
      "E96"
    ],
    "notes": [],
    "accords": [
      "würzig",
      "holzig"
    ],
    "directionTerms": [
      "würzig",
      "holzig"
    ],
    "directProductTerms": [
      "Solvag Elixiiir",
      "E-96",
      "E96",
      "e-96-sau_vage-elixiiir"
    ],
    "shopHandle": "e-96-sau_vage-elixiiir",
    "handle": "e-96-sau_vage-elixiiir",
    "shopCode": "E-96",
    "shopProduct": "Solvag Elixiiir",
    "productUrl": "https://dieduftquelle.com/products/e-96-sau_vage-elixiiir",
    "confidence": 100,
    "direction": "würzig - holzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-black-orchid",
    "brand": "Tom Ford",
    "name": "Black Orchid",
    "variant": "",
    "searchTerms": [
      "Black Orchid",
      "Tom Ford Black Orchid",
      "U-1 - Black Orchid",
      "U-1",
      "U1",
      "TF Black Orchid",
      "Black",
      "Orchid"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "orientalisch"
    ],
    "directionTerms": [
      "blumig",
      "orientalisch"
    ],
    "directProductTerms": [
      "U-1 - Black Orchid",
      "U-1",
      "U1",
      "u-1-black-orchid"
    ],
    "shopHandle": "u-1-black-orchid",
    "handle": "u-1-black-orchid",
    "shopCode": "U-1",
    "shopProduct": "U-1 - Black Orchid",
    "productUrl": "https://dieduftquelle.com/products/u-1-black-orchid",
    "confidence": 100,
    "direction": "blumig - orientalisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "yves-saint-laurent-black-opium",
    "brand": "Yves Saint Laurent",
    "name": "Black Opium",
    "variant": "",
    "searchTerms": [
      "Black Opium",
      "Yves Saint Laurent Black Opium",
      "W-1 - Black Opium",
      "W-1",
      "W1",
      "YSL Black Opium",
      "Saint Laurent Black Opium",
      "Opium Black",
      "Black",
      "Opium"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "W-1 - Black Opium",
      "W-1",
      "W1",
      "w-1-black-opium"
    ],
    "shopHandle": "w-1-black-opium",
    "handle": "w-1-black-opium",
    "shopCode": "W-1",
    "shopProduct": "W-1 - Black Opium",
    "productUrl": "https://dieduftquelle.com/products/w-1-black-opium",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "yves-saint-laurent-libre",
    "brand": "Yves Saint Laurent",
    "name": "Libre",
    "variant": "",
    "searchTerms": [
      "Libre",
      "Yves Saint Laurent Libre",
      "W-46 - Libra",
      "W-46",
      "W46",
      "YSL Libre",
      "Saint Laurent Libre",
      "Libra"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "süß"
    ],
    "directionTerms": [
      "blumig",
      "süß"
    ],
    "directProductTerms": [
      "W-46 - Libra",
      "W-46",
      "W46",
      "w-46-alternative-zu-libre"
    ],
    "shopHandle": "w-46-alternative-zu-libre",
    "handle": "w-46-alternative-zu-libre",
    "shopCode": "W-46",
    "shopProduct": "W-46 - Libra",
    "productUrl": "https://dieduftquelle.com/products/w-46-alternative-zu-libre",
    "confidence": 100,
    "direction": "blumig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "montale-roses-musk",
    "brand": "Montale",
    "name": "Roses Musk",
    "variant": "",
    "searchTerms": [
      "Roses Musk",
      "Montale Roses Musk",
      "W-47 - Roses Musk",
      "W-47",
      "W47",
      "Roses"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "pudrig"
    ],
    "directionTerms": [
      "blumig",
      "pudrig"
    ],
    "directProductTerms": [
      "W-47 - Roses Musk",
      "W-47",
      "W47",
      "w-47-roses-musk"
    ],
    "shopHandle": "w-47-roses-musk",
    "handle": "w-47-roses-musk",
    "shopCode": "W-47",
    "shopProduct": "W-47 - Roses Musk",
    "productUrl": "https://dieduftquelle.com/products/w-47-roses-musk",
    "confidence": 100,
    "direction": "blumig - pudrig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "giorgio-armani-my-way",
    "brand": "Giorgio Armani",
    "name": "My Way",
    "variant": "",
    "searchTerms": [
      "My Way",
      "Giorgio Armani My Way",
      "W-51 - My Way",
      "W-51",
      "W51",
      "Armani My Way"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "süß"
    ],
    "directionTerms": [
      "blumig",
      "süß"
    ],
    "directProductTerms": [
      "W-51 - My Way",
      "W-51",
      "W51",
      "w-51-alternative-zu-myway"
    ],
    "shopHandle": "w-51-alternative-zu-myway",
    "handle": "w-51-alternative-zu-myway",
    "shopCode": "W-51",
    "shopProduct": "W-51 - My Way",
    "productUrl": "https://dieduftquelle.com/products/w-51-alternative-zu-myway",
    "confidence": 100,
    "direction": "blumig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "byredo-black-saffron",
    "brand": "Byredo",
    "name": "Black Saffron",
    "variant": "",
    "searchTerms": [
      "Black Saffron",
      "Byredo Black Saffron",
      "Bl. Safron",
      "Black",
      "Saffron",
      "E-30",
      "E30"
    ],
    "notes": [],
    "accords": [
      "ledrig",
      "fruchtig"
    ],
    "directionTerms": [
      "ledrig",
      "fruchtig"
    ],
    "directProductTerms": [
      "Bl. Safron",
      "E-30",
      "E30",
      "e-30-b-safron"
    ],
    "shopHandle": "e-30-b-safron",
    "handle": "e-30-b-safron",
    "shopCode": "E-30",
    "shopProduct": "Bl. Safron",
    "productUrl": "https://dieduftquelle.com/products/e-30-b-safron",
    "confidence": 100,
    "direction": "ledrig - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "parfums-de-marly-oajan",
    "brand": "Parfums de Marly",
    "name": "Oajan",
    "variant": "",
    "searchTerms": [
      "Oajan",
      "Parfums de Marly Oajan",
      "E-106 - Oajani",
      "E-106",
      "E106",
      "PDM Oajan",
      "Parfum de Marly Oajan",
      "Oajani"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "E-106 - Oajani",
      "E-106",
      "E106",
      "e-106-oajani"
    ],
    "shopHandle": "e-106-oajani",
    "handle": "e-106-oajani",
    "shopCode": "E-106",
    "shopProduct": "E-106 - Oajani",
    "productUrl": "https://dieduftquelle.com/products/e-106-oajani",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "initio-rehab",
    "brand": "Initio",
    "name": "Rehab",
    "variant": "",
    "searchTerms": [
      "Rehab",
      "Initio Rehab",
      "E-111 - Re Hab",
      "E-111",
      "E111",
      "Re Hab"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-111 - Re Hab",
      "E-111",
      "E111",
      "e-111-re-hab"
    ],
    "shopHandle": "e-111-re-hab",
    "handle": "e-111-re-hab",
    "shopCode": "E-111",
    "shopProduct": "E-111 - Re Hab",
    "productUrl": "https://dieduftquelle.com/products/e-111-re-hab",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-torino22",
    "brand": "Xerjoff",
    "name": "Torino22",
    "variant": "",
    "searchTerms": [
      "Torino22",
      "Xerjoff Torino22",
      "E-112 - Turine 22",
      "E-112",
      "E112",
      "XJ Torino22",
      "Turine 22"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-112 - Turine 22",
      "E-112",
      "E112",
      "e-112-turin-22"
    ],
    "shopHandle": "e-112-turin-22",
    "handle": "e-112-turin-22",
    "shopCode": "E-112",
    "shopProduct": "E-112 - Turine 22",
    "productUrl": "https://dieduftquelle.com/products/e-112-turin-22",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "maison-francis-kurkdjian-gentle-fluidity-silver",
    "brand": "Maison Francis Kurkdjian",
    "name": "Gentle Fluidity Silver",
    "variant": "",
    "searchTerms": [
      "Gentle Fluidity Silver",
      "Maison Francis Kurkdjian Gentle Fluidity Silver",
      "E-114 - Gentle Fluid Silber",
      "E-114",
      "E114",
      "MFK Gentle Fluidity Silver",
      "Francis Kurkdjian Gentle Fluidity Silver",
      "Gentle Fluidity",
      "Gentle Fluid Silber",
      "Gentle",
      "Fluidity",
      "Silver"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "holzig"
    ],
    "directionTerms": [
      "frisch",
      "holzig"
    ],
    "directProductTerms": [
      "E-114 - Gentle Fluid Silber",
      "E-114",
      "E114",
      "gentle-fluid-silber"
    ],
    "shopHandle": "gentle-fluid-silber",
    "handle": "gentle-fluid-silber",
    "shopCode": "E-114",
    "shopProduct": "E-114 - Gentle Fluid Silber",
    "productUrl": "https://dieduftquelle.com/products/gentle-fluid-silber",
    "confidence": 100,
    "direction": "frisch - holzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "ex-nihilo-blue-talisman",
    "brand": "Ex Nihilo",
    "name": "Blue Talisman",
    "variant": "",
    "searchTerms": [
      "Blue Talisman",
      "Ex Nihilo Blue Talisman",
      "E-115 - Bleue Talis",
      "E-115",
      "E115",
      "Bleue Talis",
      "Talisman"
    ],
    "notes": [],
    "accords": [
      "frisch fruchtig"
    ],
    "directionTerms": [
      "frisch fruchtig"
    ],
    "directProductTerms": [
      "E-115 - Bleue Talis",
      "E-115",
      "E115",
      "e-115-blue-talis"
    ],
    "shopHandle": "e-115-blue-talis",
    "handle": "e-115-blue-talis",
    "shopCode": "E-115",
    "shopProduct": "E-115 - Bleue Talis",
    "productUrl": "https://dieduftquelle.com/products/e-115-blue-talis",
    "confidence": 100,
    "direction": "frisch fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-torino21",
    "brand": "Xerjoff",
    "name": "Torino21",
    "variant": "",
    "searchTerms": [
      "Torino21",
      "Xerjoff Torino21",
      "E-116 - Turine 21",
      "E-116",
      "E116",
      "XJ Torino21",
      "Turine 21"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "Zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "Zitrisch"
    ],
    "directProductTerms": [
      "E-116 - Turine 21",
      "E-116",
      "E116",
      "e-116-turin-21"
    ],
    "shopHandle": "e-116-turin-21",
    "handle": "e-116-turin-21",
    "shopCode": "E-116",
    "shopProduct": "E-116 - Turine 21",
    "productUrl": "https://dieduftquelle.com/products/e-116-turin-21",
    "confidence": 100,
    "direction": "frisch - Zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "givenchy-gentleman-society",
    "brand": "Givenchy",
    "name": "Gentleman Society",
    "variant": "",
    "searchTerms": [
      "Gentleman Society",
      "Givenchy Gentleman Society",
      "E-118 - Gentleman S",
      "E-118",
      "E118",
      "Gentleman S",
      "Gentleman",
      "Society"
    ],
    "notes": [],
    "accords": [
      "süß",
      "pudrig"
    ],
    "directionTerms": [
      "süß",
      "pudrig"
    ],
    "directProductTerms": [
      "E-118 - Gentleman S",
      "E-118",
      "E118",
      "e-118-gentleman-society-1"
    ],
    "shopHandle": "e-118-gentleman-society-1",
    "handle": "e-118-gentleman-society-1",
    "shopCode": "E-118",
    "shopProduct": "E-118 - Gentleman S",
    "productUrl": "https://dieduftquelle.com/products/e-118-gentleman-society-1",
    "confidence": 100,
    "direction": "süß - pudrig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-40-knots",
    "brand": "Xerjoff",
    "name": "40 Knots",
    "variant": "",
    "searchTerms": [
      "40 Knots",
      "Xerjoff 40 Knots",
      "E-120 - 4.0 Not",
      "E-120",
      "E120",
      "XJ 40 Knots",
      "4.0 Not",
      "Knots"
    ],
    "notes": [],
    "accords": [
      "aquatisch",
      "holzig"
    ],
    "directionTerms": [
      "aquatisch",
      "holzig"
    ],
    "directProductTerms": [
      "E-120 - 4.0 Not",
      "E-120",
      "E120",
      "e-120-40-knot"
    ],
    "shopHandle": "e-120-40-knot",
    "handle": "e-120-40-knot",
    "shopCode": "E-120",
    "shopProduct": "E-120 - 4.0 Not",
    "productUrl": "https://dieduftquelle.com/products/e-120-40-knot",
    "confidence": 100,
    "direction": "aquatisch - holzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "initio-paragon",
    "brand": "Initio",
    "name": "Paragon",
    "variant": "",
    "searchTerms": [
      "Paragon",
      "Initio Paragon",
      "E-123 - Paragone",
      "E-123",
      "E123",
      "Paragone"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "cremig"
    ],
    "directionTerms": [
      "fruchtig",
      "cremig"
    ],
    "directProductTerms": [
      "E-123 - Paragone",
      "E-123",
      "E123",
      "e-123-paragon"
    ],
    "shopHandle": "e-123-paragon",
    "handle": "e-123-paragon",
    "shopCode": "E-123",
    "shopProduct": "E-123 - Paragone",
    "productUrl": "https://dieduftquelle.com/products/e-123-paragon",
    "confidence": 100,
    "direction": "fruchtig - cremig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "initio-side-effect",
    "brand": "Initio",
    "name": "Side Effect",
    "variant": "",
    "searchTerms": [
      "Side Effect",
      "Initio Side Effect",
      "E-124 - S. Effect",
      "E-124",
      "E124",
      "S. Effect",
      "Effect"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-124 - S. Effect",
      "E-124",
      "E124",
      "e-124-effect"
    ],
    "shopHandle": "e-124-effect",
    "handle": "e-124-effect",
    "shopCode": "E-124",
    "shopProduct": "E-124 - S. Effect",
    "productUrl": "https://dieduftquelle.com/products/e-124-effect",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "guerlain-tobacco-honey",
    "brand": "Guerlain",
    "name": "Tobacco Honey",
    "variant": "",
    "searchTerms": [
      "Tobacco Honey",
      "Guerlain Tobacco Honey",
      "E-127 - Tobacco Honey",
      "E-127",
      "E127",
      "Tobacco",
      "Honey"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-127 - Tobacco Honey",
      "E-127",
      "E127",
      "e-127-tobacco-honey"
    ],
    "shopHandle": "e-127-tobacco-honey",
    "handle": "e-127-tobacco-honey",
    "shopCode": "E-127",
    "shopProduct": "E-127 - Tobacco Honey",
    "productUrl": "https://dieduftquelle.com/products/e-127-tobacco-honey",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "bdk-parfums-rouge-smoking",
    "brand": "BDK Parfums",
    "name": "Rouge Smoking",
    "variant": "",
    "searchTerms": [
      "Rouge Smoking",
      "BDK Parfums Rouge Smoking",
      "E-128 - Rouge Smokes",
      "E-128",
      "E128",
      "Rouge Smokes",
      "Rouge",
      "Smoking"
    ],
    "notes": [],
    "accords": [
      "süß",
      "fruchtig"
    ],
    "directionTerms": [
      "süß",
      "fruchtig"
    ],
    "directProductTerms": [
      "E-128 - Rouge Smokes",
      "E-128",
      "E128",
      "e-128-rouge-smoking"
    ],
    "shopHandle": "e-128-rouge-smoking",
    "handle": "e-128-rouge-smoking",
    "shopCode": "E-128",
    "shopProduct": "E-128 - Rouge Smokes",
    "productUrl": "https://dieduftquelle.com/products/e-128-rouge-smoking",
    "confidence": 100,
    "direction": "süß - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "yves-saint-laurent-la-nuit-de-l-homme",
    "brand": "Yves Saint Laurent",
    "name": "La Nuit de L'Homme",
    "variant": "",
    "searchTerms": [
      "La Nuit de L'Homme",
      "Yves Saint Laurent La Nuit de L'Homme",
      "E-13 Nuit de L‘homme",
      "E-13",
      "E13",
      "YSL La Nuit de L'Homme",
      "Saint Laurent La Nuit de L'Homme",
      "Nuit de L‘homme"
    ],
    "notes": [],
    "accords": [
      "würzig",
      "süß"
    ],
    "directionTerms": [
      "würzig",
      "süß"
    ],
    "directProductTerms": [
      "E-13 Nuit de L‘homme",
      "E-13",
      "E13",
      "e-13-nuit-de-l-homme"
    ],
    "shopHandle": "e-13-nuit-de-l-homme",
    "handle": "e-13-nuit-de-l-homme",
    "shopCode": "E-13",
    "shopProduct": "E-13 Nuit de L‘homme",
    "productUrl": "https://dieduftquelle.com/products/e-13-nuit-de-l-homme",
    "confidence": 100,
    "direction": "würzig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-oud-wood",
    "brand": "Tom Ford",
    "name": "Oud Wood",
    "variant": "",
    "searchTerms": [
      "Oud Wood",
      "Tom Ford Oud Wood",
      "E-25 - OWood",
      "E-25",
      "E25",
      "TF Oud Wood",
      "OWood"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "würzig"
    ],
    "directionTerms": [
      "holzig",
      "würzig"
    ],
    "directProductTerms": [
      "E-25 - OWood",
      "E-25",
      "E25",
      "e-25-o-wood"
    ],
    "shopHandle": "e-25-o-wood",
    "handle": "e-25-o-wood",
    "shopCode": "E-25",
    "shopProduct": "E-25 - OWood",
    "productUrl": "https://dieduftquelle.com/products/e-25-o-wood",
    "confidence": 100,
    "direction": "holzig - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-richwood",
    "brand": "Xerjoff",
    "name": "Richwood",
    "variant": "",
    "searchTerms": [
      "Richwood",
      "Xerjoff Richwood",
      "E-31 - Richest Wood",
      "E-31",
      "E31",
      "XJ Richwood",
      "Richest Wood"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "würzig"
    ],
    "directionTerms": [
      "holzig",
      "würzig"
    ],
    "directProductTerms": [
      "E-31 - Richest Wood",
      "E-31",
      "E31",
      "rich-wood"
    ],
    "shopHandle": "rich-wood",
    "handle": "rich-wood",
    "shopCode": "E-31",
    "shopProduct": "E-31 - Richest Wood",
    "productUrl": "https://dieduftquelle.com/products/rich-wood",
    "confidence": 100,
    "direction": "holzig - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "parfums-de-marly-sedley",
    "brand": "Parfums de Marly",
    "name": "Sedley",
    "variant": "",
    "searchTerms": [
      "Sedley",
      "Parfums de Marly Sedley",
      "E-33 - Sed Ly",
      "E-33",
      "E33",
      "PDM Sedley",
      "Parfum de Marly Sedley",
      "Sed Ly"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "zitrisch"
    ],
    "directProductTerms": [
      "E-33 - Sed Ly",
      "E-33",
      "E33",
      "e-33-sed-ley"
    ],
    "shopHandle": "e-33-sed-ley",
    "handle": "e-33-sed-ley",
    "shopCode": "E-33",
    "shopProduct": "E-33 - Sed Ly",
    "productUrl": "https://dieduftquelle.com/products/e-33-sed-ley",
    "confidence": 100,
    "direction": "frisch - zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "chanel-bleu-de-chanel",
    "brand": "Chanel",
    "name": "Bleu de Chanel",
    "variant": "",
    "searchTerms": [
      "Bleu de Chanel",
      "Chanel Bleu de Chanel",
      "E-38 - Bleu de",
      "E-38",
      "E38",
      "Bleu de",
      "Chanel"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "zitrisch"
    ],
    "directProductTerms": [
      "E-38 - Bleu de",
      "E-38",
      "E38",
      "e-38-bleu-de"
    ],
    "shopHandle": "e-38-bleu-de",
    "handle": "e-38-bleu-de",
    "shopCode": "E-38",
    "shopProduct": "E-38 - Bleu de",
    "productUrl": "https://dieduftquelle.com/products/e-38-bleu-de",
    "confidence": 100,
    "direction": "frisch - zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "creed-aventus",
    "brand": "Creed",
    "name": "Aventus",
    "variant": "",
    "searchTerms": [
      "Aventus",
      "Creed Aventus",
      "E-4 - Aventis",
      "E-4",
      "E4",
      "Aventis"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "fruchtig"
    ],
    "directionTerms": [
      "frisch",
      "fruchtig"
    ],
    "directProductTerms": [
      "E-4 - Aventis",
      "E-4",
      "E4",
      "e-4-aventi"
    ],
    "shopHandle": "e-4-aventi",
    "handle": "e-4-aventi",
    "shopCode": "E-4",
    "shopProduct": "E-4 - Aventis",
    "productUrl": "https://dieduftquelle.com/products/e-4-aventi",
    "confidence": 100,
    "direction": "frisch - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "versace-eros",
    "brand": "Versace",
    "name": "Eros",
    "variant": "",
    "searchTerms": [
      "Eros",
      "Versace Eros",
      "E-41 - Eros",
      "E-41",
      "E41"
    ],
    "notes": [],
    "accords": [
      "süß",
      "frisch"
    ],
    "directionTerms": [
      "süß",
      "frisch"
    ],
    "directProductTerms": [
      "E-41 - Eros",
      "E-41",
      "E41",
      "e-41-eros"
    ],
    "shopHandle": "e-41-eros",
    "handle": "e-41-eros",
    "shopCode": "E-41",
    "shopProduct": "E-41 - Eros",
    "productUrl": "https://dieduftquelle.com/products/e-41-eros",
    "confidence": 100,
    "direction": "süß - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kilian-angels-share",
    "brand": "Kilian",
    "name": "Angels' Share",
    "variant": "",
    "searchTerms": [
      "Angels' Share",
      "Kilian Angels' Share",
      "E-42 - Angel Share",
      "E-42",
      "E42",
      "Angel Share",
      "Angels",
      "Share"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "E-42 - Angel Share",
      "E-42",
      "E42",
      "e-42-angel"
    ],
    "shopHandle": "e-42-angel",
    "handle": "e-42-angel",
    "shopCode": "E-42",
    "shopProduct": "E-42 - Angel Share",
    "productUrl": "https://dieduftquelle.com/products/e-42-angel",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dior-bois-d-argent",
    "brand": "Dior",
    "name": "Bois d'Argent",
    "variant": "",
    "searchTerms": [
      "Bois d'Argent",
      "Dior Bois d'Argent",
      "E-44 - Bois Argente",
      "E-44",
      "E44",
      "Bois Argente",
      "Argent"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "pudrig"
    ],
    "directionTerms": [
      "holzig",
      "pudrig"
    ],
    "directProductTerms": [
      "E-44 - Bois Argente",
      "E-44",
      "E44",
      "e-44-bois-d-argent"
    ],
    "shopHandle": "e-44-bois-d-argent",
    "handle": "e-44-bois-d-argent",
    "shopCode": "E-44",
    "shopProduct": "E-44 - Bois Argente",
    "productUrl": "https://dieduftquelle.com/products/e-44-bois-d-argent",
    "confidence": 100,
    "direction": "holzig - pudrig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "initio-oud-for-greatness",
    "brand": "Initio",
    "name": "Oud for Greatness",
    "variant": "",
    "searchTerms": [
      "Oud for Greatness",
      "Initio Oud for Greatness",
      "E-46 - O. for Greatness",
      "E-46",
      "E46",
      "O. for Greatness",
      "Greatness"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "würzig"
    ],
    "directionTerms": [
      "holzig",
      "würzig"
    ],
    "directProductTerms": [
      "E-46 - O. for Greatness",
      "E-46",
      "E46",
      "e-46-oud-for-great"
    ],
    "shopHandle": "e-46-oud-for-great",
    "handle": "e-46-oud-for-great",
    "shopCode": "E-46",
    "shopProduct": "E-46 - O. for Greatness",
    "productUrl": "https://dieduftquelle.com/products/e-46-oud-for-great",
    "confidence": 100,
    "direction": "holzig- würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-uden",
    "brand": "Xerjoff",
    "name": "Uden",
    "variant": "",
    "searchTerms": [
      "Uden",
      "Xerjoff Uden",
      "E-53 - Udjen",
      "E-53",
      "E53",
      "XJ Uden",
      "Udjen"
    ],
    "notes": [],
    "accords": [
      "zitrisch",
      "frisch"
    ],
    "directionTerms": [
      "zitrisch",
      "frisch"
    ],
    "directProductTerms": [
      "E-53 - Udjen",
      "E-53",
      "E53",
      "e-35-uden"
    ],
    "shopHandle": "e-35-uden",
    "handle": "e-35-uden",
    "shopCode": "E-53",
    "shopProduct": "E-53 - Udjen",
    "productUrl": "https://dieduftquelle.com/products/e-35-uden",
    "confidence": 100,
    "direction": "zitrisch - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "nishane-ani",
    "brand": "Nishane",
    "name": "Ani",
    "variant": "",
    "searchTerms": [
      "Ani",
      "Nishane Ani",
      "E-55 - Anii",
      "E-55",
      "E55",
      "Anii"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-55 - Anii",
      "E-55",
      "E55",
      "e-55-anii"
    ],
    "shopHandle": "e-55-anii",
    "handle": "e-55-anii",
    "shopCode": "E-55",
    "shopProduct": "E-55 - Anii",
    "productUrl": "https://dieduftquelle.com/products/e-55-anii",
    "confidence": 100,
    "direction": "süß-würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "nasomatto-silver-musk",
    "brand": "Nasomatto",
    "name": "Silver Musk",
    "variant": "",
    "searchTerms": [
      "Silver Musk",
      "Nasomatto Silver Musk",
      "E-60 - Silver Musk",
      "E-60",
      "E60",
      "Silver"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "pudrig"
    ],
    "directionTerms": [
      "frisch",
      "pudrig"
    ],
    "directProductTerms": [
      "E-60 - Silver Musk",
      "E-60",
      "E60",
      "e-60-s-musk"
    ],
    "shopHandle": "e-60-s-musk",
    "handle": "e-60-s-musk",
    "shopCode": "E-60",
    "shopProduct": "E-60 - Silver Musk",
    "productUrl": "https://dieduftquelle.com/products/e-60-s-musk",
    "confidence": 100,
    "direction": "frisch - pudrig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "maison-francis-kurkdjian-oud-satin-mood",
    "brand": "Maison Francis Kurkdjian",
    "name": "Oud Satin Mood",
    "variant": "",
    "searchTerms": [
      "Oud Satin Mood",
      "Maison Francis Kurkdjian Oud Satin Mood",
      "E-69 - Satin Mood",
      "E-69",
      "E69",
      "MFK Oud Satin Mood",
      "Francis Kurkdjian Oud Satin Mood",
      "Satin Mood",
      "Satin"
    ],
    "notes": [],
    "accords": [
      "süß",
      "blumig"
    ],
    "directionTerms": [
      "süß",
      "blumig"
    ],
    "directProductTerms": [
      "E-69 - Satin Mood",
      "E-69",
      "E69",
      "e-69-satin-mood"
    ],
    "shopHandle": "e-69-satin-mood",
    "handle": "e-69-satin-mood",
    "shopCode": "E-69",
    "shopProduct": "E-69 - Satin Mood",
    "productUrl": "https://dieduftquelle.com/products/e-69-satin-mood",
    "confidence": 100,
    "direction": "süß-blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "jean-paul-gaultier-gaultier-2-2005",
    "brand": "Jean Paul Gaultier",
    "name": "Gaultier 2 (2005)",
    "variant": "",
    "searchTerms": [
      "Gaultier 2 (2005)",
      "Jean Paul Gaultier Gaultier 2 (2005)",
      "E-73 GTier II (2005)",
      "E-73",
      "E73",
      "JPG Gaultier 2 (2005)",
      "GTier II (2005)",
      "Gaultier"
    ],
    "notes": [],
    "accords": [
      "süß",
      "orientalisch"
    ],
    "directionTerms": [
      "süß",
      "orientalisch"
    ],
    "directProductTerms": [
      "E-73 GTier II (2005)",
      "E-73",
      "E73",
      "e-73-gaultier-ii"
    ],
    "shopHandle": "e-73-gaultier-ii",
    "handle": "e-73-gaultier-ii",
    "shopCode": "E-73",
    "shopProduct": "E-73 GTier II (2005)",
    "productUrl": "https://dieduftquelle.com/products/e-73-gaultier-ii",
    "confidence": 100,
    "direction": "süß - orientalisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "montale-intense-cafe",
    "brand": "Montale",
    "name": "Intense Café",
    "variant": "",
    "searchTerms": [
      "Intense Café",
      "Montale Intense Café",
      "E-75 - Café Intense",
      "E-75",
      "E75",
      "Intense Cafe",
      "Montale Intense Cafe",
      "E-75 - Cafe Intense",
      "Café Intense",
      "Intense"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "E-75 - Café Intense",
      "E-75",
      "E75",
      "e-75-cafe-intense"
    ],
    "shopHandle": "e-75-cafe-intense",
    "handle": "e-75-cafe-intense",
    "shopCode": "E-75",
    "shopProduct": "E-75 - Café Intense",
    "productUrl": "https://dieduftquelle.com/products/e-75-cafe-intense",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-fucking-fabulous",
    "brand": "Tom Ford",
    "name": "Fucking Fabulous",
    "variant": "",
    "searchTerms": [
      "Fucking Fabulous",
      "Tom Ford Fucking Fabulous",
      "E-82 - Fu—ing Fab",
      "E-82",
      "E82",
      "TF Fucking Fabulous",
      "Fu—ing Fab",
      "Fucking",
      "Fabulous"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-82 - Fu—ing Fab",
      "E-82",
      "E82",
      "e-82-fu-ing"
    ],
    "shopHandle": "e-82-fu-ing",
    "handle": "e-82-fu-ing",
    "shopCode": "E-82",
    "shopProduct": "E-82 - Fu—ing Fab",
    "productUrl": "https://dieduftquelle.com/products/e-82-fu-ing",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "maison-francis-kurkdjian-grand-soir",
    "brand": "Maison Francis Kurkdjian",
    "name": "Grand Soir",
    "variant": "",
    "searchTerms": [
      "Grand Soir",
      "Maison Francis Kurkdjian Grand Soir",
      "E-84 - GranSoir",
      "E-84",
      "E84",
      "MFK Grand Soir",
      "Francis Kurkdjian Grand Soir",
      "GranSoir",
      "Grand"
    ],
    "notes": [],
    "accords": [
      "süß",
      "harzig"
    ],
    "directionTerms": [
      "süß",
      "harzig"
    ],
    "directProductTerms": [
      "E-84 - GranSoir",
      "E-84",
      "E84",
      "e-84-grand-soir"
    ],
    "shopHandle": "e-84-grand-soir",
    "handle": "e-84-grand-soir",
    "shopCode": "E-84",
    "shopProduct": "E-84 - GranSoir",
    "productUrl": "https://dieduftquelle.com/products/e-84-grand-soir",
    "confidence": 100,
    "direction": "süß - harzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-alexandria-ii",
    "brand": "Xerjoff",
    "name": "Alexandria II",
    "variant": "",
    "searchTerms": [
      "Alexandria II",
      "Xerjoff Alexandria II",
      "E-9 - Alex II",
      "E-9",
      "E9",
      "XJ Alexandria II",
      "Alex II",
      "Alexandria"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "orientalisch"
    ],
    "directionTerms": [
      "holzig",
      "orientalisch"
    ],
    "directProductTerms": [
      "E-9 - Alex II",
      "E-9",
      "E9",
      "e-9-alex-ii"
    ],
    "shopHandle": "e-9-alex-ii",
    "handle": "e-9-alex-ii",
    "shopCode": "E-9",
    "shopProduct": "E-9 - Alex II",
    "productUrl": "https://dieduftquelle.com/products/e-9-alex-ii",
    "confidence": 100,
    "direction": "holzig - orientalisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kilian-love-don-t-be-shy",
    "brand": "Kilian",
    "name": "Love, Don't Be Shy",
    "variant": "",
    "searchTerms": [
      "Love, Don't Be Shy",
      "Kilian Love, Don't Be Shy",
      "E-98 - Don’t Shy",
      "E-98",
      "E98",
      "Don’t Shy"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "E-98 - Don’t Shy",
      "E-98",
      "E98",
      "e-98-shy"
    ],
    "shopHandle": "e-98-shy",
    "handle": "e-98-shy",
    "shopCode": "E-98",
    "shopProduct": "E-98 - Don’t Shy",
    "productUrl": "https://dieduftquelle.com/products/e-98-shy",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "roja-parfums-elysium",
    "brand": "Roja Parfums",
    "name": "Elysium",
    "variant": "",
    "searchTerms": [
      "Elysium",
      "Roja Parfums Elysium",
      "Elyisium",
      "E-58",
      "E58"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "zitrisch"
    ],
    "directProductTerms": [
      "Elyisium",
      "E-58",
      "E58",
      "e-58-elyisium"
    ],
    "shopHandle": "e-58-elyisium",
    "handle": "e-58-elyisium",
    "shopCode": "E-58",
    "shopProduct": "Elyisium",
    "productUrl": "https://dieduftquelle.com/products/e-58-elyisium",
    "confidence": 100,
    "direction": "frisch - zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "roja-parfums-enigma",
    "brand": "Roja Parfums",
    "name": "Enigma",
    "variant": "",
    "searchTerms": [
      "Enigma",
      "Roja Parfums Enigma",
      "Enygmar",
      "E-66",
      "E66"
    ],
    "notes": [],
    "accords": [
      "würzig",
      "süß"
    ],
    "directionTerms": [
      "würzig",
      "süß"
    ],
    "directProductTerms": [
      "Enygmar",
      "E-66",
      "E66",
      "e-66-enygma"
    ],
    "shopHandle": "e-66-enygma",
    "handle": "e-66-enygma",
    "shopCode": "E-66",
    "shopProduct": "Enygmar",
    "productUrl": "https://dieduftquelle.com/products/e-66-enygma",
    "confidence": 100,
    "direction": "würzig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "carolina-herrera-good-girl",
    "brand": "Carolina Herrera",
    "name": "Good Girl",
    "variant": "",
    "searchTerms": [
      "Good Girl",
      "Carolina Herrera Good Girl",
      "G. Girl",
      "W-5",
      "W5"
    ],
    "notes": [],
    "accords": [
      "süß",
      "blumig"
    ],
    "directionTerms": [
      "süß",
      "blumig"
    ],
    "directProductTerms": [
      "G. Girl",
      "W-5",
      "W5",
      "w-5-g-girl"
    ],
    "shopHandle": "w-5-g-girl",
    "handle": "w-5-g-girl",
    "shopCode": "W-5",
    "shopProduct": "G. Girl",
    "productUrl": "https://dieduftquelle.com/products/w-5-g-girl",
    "confidence": 100,
    "direction": "süß - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dior-hypnotic-poison",
    "brand": "Dior",
    "name": "Hypnotic Poison",
    "variant": "",
    "searchTerms": [
      "Hypnotic Poison",
      "Dior Hypnotic Poison",
      "H. Poison",
      "Hypnotic",
      "Poison",
      "W-16",
      "W16"
    ],
    "notes": [],
    "accords": [
      "süß",
      "orientalisch"
    ],
    "directionTerms": [
      "süß",
      "orientalisch"
    ],
    "directProductTerms": [
      "H. Poison",
      "W-16",
      "W16",
      "w-16-h-poison"
    ],
    "shopHandle": "w-16-h-poison",
    "handle": "w-16-h-poison",
    "shopCode": "W-16",
    "shopProduct": "H. Poison",
    "productUrl": "https://dieduftquelle.com/products/w-16-h-poison",
    "confidence": 100,
    "direction": "süß - orientalisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dior-dior-homme-intense",
    "brand": "Dior",
    "name": "Dior Homme Intense",
    "variant": "",
    "searchTerms": [
      "Dior Homme Intense",
      "Dior Dior Homme Intense",
      "Homme Intense Dyor",
      "Intense",
      "E-61",
      "E61"
    ],
    "notes": [],
    "accords": [
      "pudrig",
      "süß"
    ],
    "directionTerms": [
      "pudrig",
      "süß"
    ],
    "directProductTerms": [
      "Homme Intense Dyor",
      "E-61",
      "E61",
      "e-61-homme-intense"
    ],
    "shopHandle": "e-61-homme-intense",
    "handle": "e-61-homme-intense",
    "shopCode": "E-61",
    "shopProduct": "Homme Intense Dyor",
    "productUrl": "https://dieduftquelle.com/products/e-61-homme-intense",
    "confidence": 100,
    "direction": "pudrig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "maison-margiela-jazz-club",
    "brand": "Maison Margiela",
    "name": "Jazz Club",
    "variant": "",
    "searchTerms": [
      "Jazz Club",
      "Maison Margiela Jazz Club",
      "Jazzy Club",
      "Margiela Jazz Club",
      "Replica Jazz Club",
      "E-80",
      "E80"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "Jazzy Club",
      "E-80",
      "E80",
      "e-80-jazzy-club"
    ],
    "shopHandle": "e-80-jazzy-club",
    "handle": "e-80-jazzy-club",
    "shopCode": "E-80",
    "shopProduct": "Jazzy Club",
    "productUrl": "https://dieduftquelle.com/products/e-80-jazzy-club",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "orto-parisi-megamare",
    "brand": "Orto Parisi",
    "name": "Megamare",
    "variant": "",
    "searchTerms": [
      "Megamare",
      "Orto Parisi Megamare",
      "L-16 - Mega Marje",
      "L-16",
      "L16",
      "Mega Marje"
    ],
    "notes": [],
    "accords": [
      "aquatisch",
      "würzig"
    ],
    "directionTerms": [
      "aquatisch",
      "würzig"
    ],
    "directProductTerms": [
      "L-16 - Mega Marje",
      "L-16",
      "L16",
      "l-16-mega-mare"
    ],
    "shopHandle": "l-16-mega-mare",
    "handle": "l-16-mega-mare",
    "shopCode": "L-16",
    "shopProduct": "L-16 - Mega Marje",
    "productUrl": "https://dieduftquelle.com/products/l-16-mega-mare",
    "confidence": 100,
    "direction": "aquatisch - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "initio-absolute-aphrodisiac",
    "brand": "Initio",
    "name": "Absolute Aphrodisiac",
    "variant": "",
    "searchTerms": [
      "Absolute Aphrodisiac",
      "Initio Absolute Aphrodisiac",
      "L-17 - Absolut Aphfrodisiac",
      "L-17",
      "L17",
      "Absolut Aphfrodisiac",
      "Absolute",
      "Aphrodisiac"
    ],
    "notes": [],
    "accords": [
      "süß",
      "Gourmand"
    ],
    "directionTerms": [
      "süß",
      "Gourmand"
    ],
    "directProductTerms": [
      "L-17 - Absolut Aphfrodisiac",
      "L-17",
      "L17",
      "l-17-absolut-aphfrodisiac"
    ],
    "shopHandle": "l-17-absolut-aphfrodisiac",
    "handle": "l-17-absolut-aphfrodisiac",
    "shopCode": "L-17",
    "shopProduct": "L-17 - Absolut Aphfrodisiac",
    "productUrl": "https://dieduftquelle.com/products/l-17-absolut-aphfrodisiac",
    "confidence": 100,
    "direction": "süß - Gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-oud-wood-intense",
    "brand": "Tom Ford",
    "name": "Oud Wood Intense",
    "variant": "",
    "searchTerms": [
      "Oud Wood Intense",
      "Tom Ford Oud Wood Intense",
      "L-2 - OWood Intense",
      "L-2",
      "L2",
      "TF Oud Wood Intense",
      "OWood Intense",
      "Intense"
    ],
    "notes": [],
    "accords": [],
    "directionTerms": [],
    "directProductTerms": [
      "L-2 - OWood Intense",
      "L-2",
      "L2",
      "e-111-oud-wood-intense"
    ],
    "shopHandle": "e-111-oud-wood-intense",
    "handle": "e-111-oud-wood-intense",
    "shopCode": "L-2",
    "shopProduct": "L-2 - OWood Intense",
    "productUrl": "https://dieduftquelle.com/products/e-111-oud-wood-intense",
    "confidence": 100,
    "direction": "",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "giardini-di-toscana-bianco-latte",
    "brand": "Giardini di Toscana",
    "name": "Bianco Latte",
    "variant": "",
    "searchTerms": [
      "Bianco Latte",
      "Giardini di Toscana Bianco Latte",
      "L-34 - Bien Latte",
      "L-34",
      "L34",
      "Bien Latte",
      "Bianco",
      "Latte"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "L-34 - Bien Latte",
      "L-34",
      "L34",
      "l-34-bianco-latte"
    ],
    "shopHandle": "l-34-bianco-latte",
    "handle": "l-34-bianco-latte",
    "shopCode": "L-34",
    "shopProduct": "L-34 - Bien Latte",
    "productUrl": "https://dieduftquelle.com/products/l-34-bianco-latte",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "jean-paul-gaultier-le-male-le-parfum",
    "brand": "Jean Paul Gaultier",
    "name": "Le Male Le Parfum",
    "variant": "",
    "searchTerms": [
      "Le Male Le Parfum",
      "Jean Paul Gaultier Le Male Le Parfum",
      "L.e. Mal Parfum",
      "JPG Le Male Le Parfum",
      "L-33",
      "L33"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "L.e. Mal Parfum",
      "L-33",
      "L33",
      "l-e-mal-parfum"
    ],
    "shopHandle": "l-e-mal-parfum",
    "handle": "l-e-mal-parfum",
    "shopCode": "L-33",
    "shopProduct": "L.e. Mal Parfum",
    "productUrl": "https://dieduftquelle.com/products/l-e-mal-parfum",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "chanel-allure-homme-sport-eau-extreme",
    "brand": "Chanel",
    "name": "Allure Homme Sport Eau Extrême",
    "variant": "",
    "searchTerms": [
      "Allure Homme Sport Eau Extrême",
      "Chanel Allure Homme Sport Eau Extrême",
      "M-12 - Allora Sport Ex.",
      "M-12",
      "M12",
      "Allure Homme Sport Eau Extreme",
      "Chanel Allure Homme Sport Eau Extreme",
      "Allora Sport Ex.",
      "Allure",
      "Sport",
      "Extrême"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "süß"
    ],
    "directionTerms": [
      "frisch",
      "süß"
    ],
    "directProductTerms": [
      "M-12 - Allora Sport Ex.",
      "M-12",
      "M12",
      "m-12-allure-h-sport-ex"
    ],
    "shopHandle": "m-12-allure-h-sport-ex",
    "handle": "m-12-allure-h-sport-ex",
    "shopCode": "M-12",
    "shopProduct": "M-12 - Allora Sport Ex.",
    "productUrl": "https://dieduftquelle.com/products/m-12-allure-h-sport-ex",
    "confidence": 100,
    "direction": "frisch - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-tobacco-vanille",
    "brand": "Tom Ford",
    "name": "Tobacco Vanille",
    "variant": "",
    "searchTerms": [
      "Tobacco Vanille",
      "Tom Ford Tobacco Vanille",
      "M-2 - Tabak Vanille",
      "M-2",
      "M2",
      "TF Tobacco Vanille",
      "Tabak Vanille",
      "Tobacco",
      "Vanille"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "M-2 - Tabak Vanille",
      "M-2",
      "M2",
      "m-2-t-vanille"
    ],
    "shopHandle": "m-2-t-vanille",
    "handle": "m-2-t-vanille",
    "shopCode": "M-2",
    "shopProduct": "M-2 - Tabak Vanille",
    "productUrl": "https://dieduftquelle.com/products/m-2-t-vanille",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "paco-rabanne-invictus",
    "brand": "Paco Rabanne",
    "name": "Invictus",
    "variant": "",
    "searchTerms": [
      "Invictus",
      "Paco Rabanne Invictus",
      "M-24 - In Vict",
      "M-24",
      "M24",
      "Rabanne Invictus",
      "In Vict"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "synthetisch"
    ],
    "directionTerms": [
      "frisch",
      "synthetisch"
    ],
    "directProductTerms": [
      "M-24 - In Vict",
      "M-24",
      "M24",
      "m-24-in-vict"
    ],
    "shopHandle": "m-24-in-vict",
    "handle": "m-24-in-vict",
    "shopCode": "M-24",
    "shopProduct": "M-24 - In Vict",
    "productUrl": "https://dieduftquelle.com/products/m-24-in-vict",
    "confidence": 100,
    "direction": "frisch - synthetisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "emporio-armani-stronger-with-you",
    "brand": "Emporio Armani",
    "name": "Stronger With You",
    "variant": "",
    "searchTerms": [
      "Stronger With You",
      "Emporio Armani Stronger With You",
      "M-26 - Strong w. U",
      "M-26",
      "M26",
      "Strong w. U",
      "Stronger"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "M-26 - Strong w. U",
      "M-26",
      "M26",
      "m-26-strong-w-u"
    ],
    "shopHandle": "m-26-strong-w-u",
    "handle": "m-26-strong-w-u",
    "shopCode": "M-26",
    "shopProduct": "M-26 - Strong w. U",
    "productUrl": "https://dieduftquelle.com/products/m-26-strong-w-u",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "giorgio-armani-acqua-di-gio",
    "brand": "Giorgio Armani",
    "name": "Acqua di Giò",
    "variant": "",
    "searchTerms": [
      "Acqua di Giò",
      "Giorgio Armani Acqua di Giò",
      "M-28 - Gio",
      "M-28",
      "M28",
      "Armani Acqua di Giò",
      "Acqua di Gio",
      "Giorgio Armani Acqua di Gio",
      "Armani Acqua di Gio",
      "Gio",
      "Acqua"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "aquatisch"
    ],
    "directionTerms": [
      "frisch",
      "aquatisch"
    ],
    "directProductTerms": [
      "M-28 - Gio",
      "M-28",
      "M28",
      "m-28-gio"
    ],
    "shopHandle": "m-28-gio",
    "handle": "m-28-gio",
    "shopCode": "M-28",
    "shopProduct": "M-28 - Gio",
    "productUrl": "https://dieduftquelle.com/products/m-28-gio",
    "confidence": 100,
    "direction": "frisch - aquatisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "nasomatto-black-afgano",
    "brand": "Nasomatto",
    "name": "Black Afgano",
    "variant": "",
    "searchTerms": [
      "Black Afgano",
      "Nasomatto Black Afgano",
      "M-3 - Black Afgan",
      "M-3",
      "M3",
      "Black Afgan",
      "Black",
      "Afgano"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "rauchig"
    ],
    "directionTerms": [
      "holzig",
      "rauchig"
    ],
    "directProductTerms": [
      "M-3 - Black Afgan",
      "M-3",
      "M3",
      "m-3-black-afgan"
    ],
    "shopHandle": "m-3-black-afgan",
    "handle": "m-3-black-afgan",
    "shopCode": "M-3",
    "shopProduct": "M-3 - Black Afgan",
    "productUrl": "https://dieduftquelle.com/products/m-3-black-afgan",
    "confidence": 100,
    "direction": "holzig-rauchig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "hugo-boss-boss-bottled",
    "brand": "Hugo Boss",
    "name": "Boss Bottled",
    "variant": "",
    "searchTerms": [
      "Boss Bottled",
      "Hugo Boss Boss Bottled",
      "M-30 BBottle",
      "M-30",
      "M30",
      "BBottle",
      "Bottled"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "fruchtig"
    ],
    "directionTerms": [
      "frisch",
      "fruchtig"
    ],
    "directProductTerms": [
      "M-30 BBottle",
      "M-30",
      "M30",
      "m-30-b-bottle"
    ],
    "shopHandle": "m-30-b-bottle",
    "handle": "m-30-b-bottle",
    "shopCode": "M-30",
    "shopProduct": "M-30 BBottle",
    "productUrl": "https://dieduftquelle.com/products/m-30-b-bottle",
    "confidence": 100,
    "direction": "frisch - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "amouage-reflection-man",
    "brand": "Amouage",
    "name": "Reflection Man",
    "variant": "",
    "searchTerms": [
      "Reflection Man",
      "Amouage Reflection Man",
      "M-32 - Reflection",
      "M-32",
      "M32",
      "Reflection"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "frisch"
    ],
    "directionTerms": [
      "blumig",
      "frisch"
    ],
    "directProductTerms": [
      "M-32 - Reflection",
      "M-32",
      "M32",
      "m-32-reflection"
    ],
    "shopHandle": "m-32-reflection",
    "handle": "m-32-reflection",
    "shopCode": "M-32",
    "shopProduct": "M-32 - Reflection",
    "productUrl": "https://dieduftquelle.com/products/m-32-reflection",
    "confidence": 100,
    "direction": "blumig - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "creed-virgin-island-water",
    "brand": "Creed",
    "name": "Virgin Island Water",
    "variant": "",
    "searchTerms": [
      "Virgin Island Water",
      "Creed Virgin Island Water",
      "M-33 - Virginia Island",
      "M-33",
      "M33",
      "Virginia Island",
      "Virgin",
      "Island",
      "Water"
    ],
    "notes": [
      "Bergamotte",
      "Limette",
      "tropische Früchte",
      "Kokoswasser",
      "Kokosmilch",
      "Jasmin",
      "weiße Blüten",
      "Tonkabohne",
      "weißer Moschus"
    ],
    "accords": [
      "frisch",
      "zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "zitrisch"
    ],
    "directProductTerms": [
      "M-33 - Virginia Island",
      "M-33",
      "M33",
      "m-33-virginia-island"
    ],
    "shopHandle": "m-33-virginia-island",
    "handle": "m-33-virginia-island",
    "shopCode": "M-33",
    "shopProduct": "M-33 - Virginia Island",
    "productUrl": "https://dieduftquelle.com/products/m-33-virginia-island",
    "confidence": 100,
    "direction": "frisch - zitrisch",
    "topNotes": "Bergamotte, Limette, tropische Früchte",
    "heartNotes": "Kokoswasser, Kokosmilch, Jasmin, weiße Blüten",
    "baseNotes": "Tonkabohne, weißer Moschus"
  },
  {
    "id": "yves-saint-laurent-y",
    "brand": "Yves Saint Laurent",
    "name": "Y",
    "variant": "",
    "searchTerms": [
      "Y",
      "Yves Saint Laurent Y",
      "M-41 - Y psilone",
      "M-41",
      "M41",
      "YSL Y",
      "Saint Laurent Y",
      "Y psilone"
    ],
    "notes": [],
    "accords": [
      "zitrisch",
      "frisch"
    ],
    "directionTerms": [
      "zitrisch",
      "frisch"
    ],
    "directProductTerms": [
      "M-41 - Y psilone",
      "M-41",
      "M41",
      "m-41-y"
    ],
    "shopHandle": "m-41-y",
    "handle": "m-41-y",
    "shopCode": "M-41",
    "shopProduct": "M-41 - Y psilone",
    "productUrl": "https://dieduftquelle.com/products/m-41-y",
    "confidence": 100,
    "direction": "zitrisch - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "giorgio-armani-armani-code",
    "brand": "Giorgio Armani",
    "name": "Armani Code",
    "variant": "",
    "searchTerms": [
      "Armani Code",
      "Giorgio Armani Armani Code",
      "M-50 - The Code",
      "M-50",
      "M50",
      "Armani Armani Code",
      "The Code",
      "Armani"
    ],
    "notes": [],
    "accords": [
      "würzig",
      "süß"
    ],
    "directionTerms": [
      "würzig",
      "süß"
    ],
    "directProductTerms": [
      "M-50 - The Code",
      "M-50",
      "M50",
      "m-50-a-code"
    ],
    "shopHandle": "m-50-a-code",
    "handle": "m-50-a-code",
    "shopCode": "M-50",
    "shopProduct": "M-50 - The Code",
    "productUrl": "https://dieduftquelle.com/products/m-50-a-code",
    "confidence": 100,
    "direction": "würzig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dior-fahrenheit",
    "brand": "Dior",
    "name": "Fahrenheit",
    "variant": "",
    "searchTerms": [
      "Fahrenheit",
      "Dior Fahrenheit",
      "M-55 - Farenheydt",
      "M-55",
      "M55",
      "Farenheydt"
    ],
    "notes": [],
    "accords": [
      "ledrig",
      "würzig"
    ],
    "directionTerms": [
      "ledrig",
      "würzig"
    ],
    "directProductTerms": [
      "M-55 - Farenheydt",
      "M-55",
      "M55",
      "m-55-farenheydt"
    ],
    "shopHandle": "m-55-farenheydt",
    "handle": "m-55-farenheydt",
    "shopCode": "M-55",
    "shopProduct": "M-55 - Farenheydt",
    "productUrl": "https://dieduftquelle.com/products/m-55-farenheydt",
    "confidence": 100,
    "direction": "ledrig - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "hermes-terre-d-hermes",
    "brand": "Hermès",
    "name": "Terre d'Hermès",
    "variant": "",
    "searchTerms": [
      "Terre d'Hermès",
      "Hermès Terre d'Hermès",
      "M-70 - Terre H",
      "M-70",
      "M70",
      "Terre d'Hermes",
      "Hermes Terre d'Hermes",
      "Terre H",
      "Terre",
      "Hermès"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "erdig"
    ],
    "directionTerms": [
      "holzig",
      "erdig"
    ],
    "directProductTerms": [
      "M-70 - Terre H",
      "M-70",
      "M70",
      "m-70-terre-de-h"
    ],
    "shopHandle": "m-70-terre-de-h",
    "handle": "m-70-terre-de-h",
    "shopCode": "M-70",
    "shopProduct": "M-70 - Terre H",
    "productUrl": "https://dieduftquelle.com/products/m-70-terre-de-h",
    "confidence": 100,
    "direction": "holzig-erdig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "emporio-armani-stronger-with-you-intensely",
    "brand": "Emporio Armani",
    "name": "Stronger With You Intensely",
    "variant": "",
    "searchTerms": [
      "Stronger With You Intensely",
      "Emporio Armani Stronger With You Intensely",
      "M-71 - Strong w. U Intense",
      "M-71",
      "M71",
      "Strong w. U Intense",
      "Stronger",
      "Intensely"
    ],
    "notes": [],
    "accords": [
      "gourmand",
      "süß"
    ],
    "directionTerms": [
      "gourmand",
      "süß"
    ],
    "directProductTerms": [
      "M-71 - Strong w. U Intense",
      "M-71",
      "M71",
      "m-71-strong-w-u-intense"
    ],
    "shopHandle": "m-71-strong-w-u-intense",
    "handle": "m-71-strong-w-u-intense",
    "shopCode": "M-71",
    "shopProduct": "M-71 - Strong w. U Intense",
    "productUrl": "https://dieduftquelle.com/products/m-71-strong-w-u-intense",
    "confidence": 100,
    "direction": "gourmand - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "paco-rabanne-1-million",
    "brand": "Paco Rabanne",
    "name": "1 Million",
    "variant": "",
    "searchTerms": [
      "1 Million",
      "Paco Rabanne 1 Million",
      "Million",
      "Rabanne 1 Million",
      "M-19",
      "M19"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "Million",
      "M-19",
      "M19"
    ],
    "shopHandle": "million",
    "handle": "million",
    "shopCode": "M-19",
    "shopProduct": "Million",
    "productUrl": "https://dieduftquelle.com/products/million",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "paco-rabanne-1-million-parfum",
    "brand": "Paco Rabanne",
    "name": "1 Million Parfum",
    "variant": "",
    "searchTerms": [
      "1 Million Parfum",
      "Paco Rabanne 1 Million Parfum",
      "Million Parfum Man",
      "Rabanne 1 Million Parfum",
      "Million",
      "E-11",
      "E11"
    ],
    "notes": [],
    "accords": [
      "süß",
      "synthetisch"
    ],
    "directionTerms": [
      "süß",
      "synthetisch"
    ],
    "directProductTerms": [
      "Million Parfum Man",
      "E-11",
      "E11",
      "e-11-million-parfum"
    ],
    "shopHandle": "e-11-million-parfum",
    "handle": "e-11-million-parfum",
    "shopCode": "E-11",
    "shopProduct": "Million Parfum Man",
    "productUrl": "https://dieduftquelle.com/products/e-11-million-parfum",
    "confidence": 100,
    "direction": "süß - synthetisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "paco-rabanne-lady-million",
    "brand": "Paco Rabanne",
    "name": "Lady Million",
    "variant": "",
    "searchTerms": [
      "Lady Million",
      "Paco Rabanne Lady Million",
      "Million Women",
      "Rabanne Lady Million",
      "Million",
      "W-20",
      "W20"
    ],
    "notes": [],
    "accords": [
      "süß",
      "blumig"
    ],
    "directionTerms": [
      "süß",
      "blumig"
    ],
    "directProductTerms": [
      "Million Women",
      "W-20",
      "W20",
      "w-20-million-women"
    ],
    "shopHandle": "w-20-million-women",
    "handle": "w-20-million-women",
    "shopCode": "W-20",
    "shopProduct": "Million Women",
    "productUrl": "https://dieduftquelle.com/products/w-20-million-women",
    "confidence": 100,
    "direction": "süß - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "diptyque-eau-rihla",
    "brand": "Diptyque",
    "name": "Eau Rihla",
    "variant": "",
    "searchTerms": [
      "Eau Rihla",
      "Diptyque Eau Rihla",
      "Rihla",
      "E-94",
      "E94"
    ],
    "notes": [],
    "accords": [
      "ledrig",
      "fruchtig"
    ],
    "directionTerms": [
      "ledrig",
      "fruchtig"
    ],
    "directProductTerms": [
      "Rihla",
      "E-94",
      "E94",
      "e-94-eau-rihla"
    ],
    "shopHandle": "e-94-eau-rihla",
    "handle": "e-94-eau-rihla",
    "shopCode": "E-94",
    "shopProduct": "Rihla",
    "productUrl": "https://dieduftquelle.com/products/e-94-eau-rihla",
    "confidence": 100,
    "direction": "ledrig - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "escentric-molecules-escentric-01",
    "brand": "Escentric Molecules",
    "name": "Escentric 01",
    "variant": "",
    "searchTerms": [
      "Escentric 01",
      "Escentric Molecules Escentric 01",
      "Sentrik 01",
      "Escentric",
      "E-14",
      "E14"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "frisch"
    ],
    "directionTerms": [
      "holzig",
      "frisch"
    ],
    "directProductTerms": [
      "Sentrik 01",
      "E-14",
      "E14",
      "esentrik-01"
    ],
    "shopHandle": "esentrik-01",
    "handle": "esentrik-01",
    "shopCode": "E-14",
    "shopProduct": "Sentrik 01",
    "productUrl": "https://dieduftquelle.com/products/esentrik-01",
    "confidence": 100,
    "direction": "holzig - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "louis-vuitton-l-immensite",
    "brand": "Louis Vuitton",
    "name": "L'Immensité",
    "variant": "",
    "searchTerms": [
      "L'Immensité",
      "Louis Vuitton L'Immensité",
      "Sité",
      "LV L'Immensité",
      "L'Immensite",
      "Louis Vuitton L'Immensite",
      "Site",
      "LV L'Immensite",
      "Immensité",
      "E-87",
      "E87"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "zitrisch"
    ],
    "directProductTerms": [
      "Sité",
      "E-87",
      "E87",
      "e-87-immensite"
    ],
    "shopHandle": "e-87-immensite",
    "handle": "e-87-immensite",
    "shopCode": "E-87",
    "shopProduct": "Sité",
    "productUrl": "https://dieduftquelle.com/products/e-87-immensite",
    "confidence": 100,
    "direction": "frisch - zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "giorgio-armani-armani-code-for-women",
    "brand": "Giorgio Armani",
    "name": "Armani Code for Women",
    "variant": "",
    "searchTerms": [
      "Armani Code for Women",
      "Giorgio Armani Armani Code for Women",
      "The Code Women",
      "Armani Armani Code for Women",
      "Armani",
      "W-52",
      "W52"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "süß"
    ],
    "directionTerms": [
      "blumig",
      "süß"
    ],
    "directProductTerms": [
      "The Code Women",
      "W-52",
      "W52",
      "w-52-code-women"
    ],
    "shopHandle": "w-52-code-women",
    "handle": "w-52-code-women",
    "shopCode": "W-52",
    "shopProduct": "The Code Women",
    "productUrl": "https://dieduftquelle.com/products/w-52-code-women",
    "confidence": 100,
    "direction": "blumig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dolce-gabbana-the-one-for-men",
    "brand": "Dolce & Gabbana",
    "name": "The One for Men",
    "variant": "",
    "searchTerms": [
      "The One for Men",
      "Dolce & Gabbana The One for Men",
      "The One",
      "D&G The One for Men",
      "Dolce Gabbana The One for Men",
      "M-34",
      "M34"
    ],
    "notes": [],
    "accords": [
      "würzig",
      "süß"
    ],
    "directionTerms": [
      "würzig",
      "süß"
    ],
    "directProductTerms": [
      "The One",
      "M-34",
      "M34",
      "m-34-the-one"
    ],
    "shopHandle": "m-34-the-one",
    "handle": "m-34-the-one",
    "shopCode": "M-34",
    "shopProduct": "The One",
    "productUrl": "https://dieduftquelle.com/products/m-34-the-one",
    "confidence": 100,
    "direction": "würzig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dior-j-adore",
    "brand": "Dior",
    "name": "J'adore",
    "variant": "",
    "searchTerms": [
      "J'adore",
      "Dior J'adore",
      "W-30 - Adore",
      "W-30",
      "W30",
      "Adore"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "süß"
    ],
    "directionTerms": [
      "blumig",
      "süß"
    ],
    "directProductTerms": [
      "W-30 - Adore",
      "W-30",
      "W30",
      "w-30-adore"
    ],
    "shopHandle": "w-30-adore",
    "handle": "w-30-adore",
    "shopCode": "W-30",
    "shopProduct": "W-30 - Adore",
    "productUrl": "https://dieduftquelle.com/products/w-30-adore",
    "confidence": 100,
    "direction": "blumig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dolce-gabbana-the-one-for-women",
    "brand": "Dolce & Gabbana",
    "name": "The One for Women",
    "variant": "",
    "searchTerms": [
      "The One for Women",
      "Dolce & Gabbana The One for Women",
      "W-31 - T. One Women",
      "W-31",
      "W31",
      "D&G The One for Women",
      "Dolce Gabbana The One for Women",
      "T. One Women"
    ],
    "notes": [],
    "accords": [
      "süß",
      "blumig"
    ],
    "directionTerms": [
      "süß",
      "blumig"
    ],
    "directProductTerms": [
      "W-31 - T. One Women",
      "W-31",
      "W31",
      "w-31-t-one-women"
    ],
    "shopHandle": "w-31-t-one-women",
    "handle": "w-31-t-one-women",
    "shopCode": "W-31",
    "shopProduct": "W-31 - T. One Women",
    "productUrl": "https://dieduftquelle.com/products/w-31-t-one-women",
    "confidence": 100,
    "direction": "süß - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "paco-rabanne-olympea",
    "brand": "Paco Rabanne",
    "name": "Olympéa",
    "variant": "",
    "searchTerms": [
      "Olympéa",
      "Paco Rabanne Olympéa",
      "W-34 Olympica",
      "W-34",
      "W34",
      "Rabanne Olympéa",
      "Olympea",
      "Paco Rabanne Olympea",
      "Rabanne Olympea",
      "Olympica"
    ],
    "notes": [],
    "accords": [
      "süß",
      "blumig"
    ],
    "directionTerms": [
      "süß",
      "blumig"
    ],
    "directProductTerms": [
      "W-34 Olympica",
      "W-34",
      "W34",
      "w-34-olympia"
    ],
    "shopHandle": "w-34-olympia",
    "handle": "w-34-olympia",
    "shopCode": "W-34",
    "shopProduct": "W-34 Olympica",
    "productUrl": "https://dieduftquelle.com/products/w-34-olympia",
    "confidence": 100,
    "direction": "süß - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "chanel-coco-mademoiselle",
    "brand": "Chanel",
    "name": "Coco Mademoiselle",
    "variant": "",
    "searchTerms": [
      "Coco Mademoiselle",
      "Chanel Coco Mademoiselle",
      "W-4 - Moiselle",
      "W-4",
      "W4",
      "Mademoiselle",
      "Chanel Mademoiselle",
      "Coco",
      "Moiselle"
    ],
    "notes": [],
    "accords": [
      "Blumig",
      "süß"
    ],
    "directionTerms": [
      "Blumig",
      "süß"
    ],
    "directProductTerms": [
      "W-4 - Moiselle",
      "W-4",
      "W4",
      "w-4-mademoiselle"
    ],
    "shopHandle": "w-4-mademoiselle",
    "handle": "w-4-mademoiselle",
    "shopCode": "W-4",
    "shopProduct": "W-4 - Moiselle",
    "productUrl": "https://dieduftquelle.com/products/w-4-mademoiselle",
    "confidence": 100,
    "direction": "Blumig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "prada-paradoxe",
    "brand": "Prada",
    "name": "Paradoxe",
    "variant": "",
    "searchTerms": [
      "Paradoxe",
      "Prada Paradoxe",
      "W-57 - Pardochse",
      "W-57",
      "W57",
      "Pardochse"
    ],
    "notes": [],
    "accords": [
      "süß",
      "blumig"
    ],
    "directionTerms": [
      "süß",
      "blumig"
    ],
    "directProductTerms": [
      "W-57 - Pardochse",
      "W-57",
      "W57",
      "w-57-paradochs"
    ],
    "shopHandle": "w-57-paradochs",
    "handle": "w-57-paradochs",
    "shopCode": "W-57",
    "shopProduct": "W-57 - Pardochse",
    "productUrl": "https://dieduftquelle.com/products/w-57-paradochs",
    "confidence": 100,
    "direction": "süß - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dolce-gabbana-light-blue",
    "brand": "Dolce & Gabbana",
    "name": "Light Blue",
    "variant": "",
    "searchTerms": [
      "Light Blue",
      "Dolce & Gabbana Light Blue",
      "W-60 - Light Blue",
      "W-60",
      "W60",
      "D&G Light Blue",
      "Dolce Gabbana Light Blue",
      "Light"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "zitrisch"
    ],
    "directProductTerms": [
      "W-60 - Light Blue",
      "W-60",
      "W60",
      "w-60-light-blue"
    ],
    "shopHandle": "w-60-light-blue",
    "handle": "w-60-light-blue",
    "shopCode": "W-60",
    "shopProduct": "W-60 - Light Blue",
    "productUrl": "https://dieduftquelle.com/products/w-60-light-blue",
    "confidence": 100,
    "direction": "frisch - zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "chanel-chance-eau-tendre",
    "brand": "Chanel",
    "name": "Chance Eau Tendre",
    "variant": "",
    "searchTerms": [
      "Chance Eau Tendre",
      "Chanel Chance Eau Tendre",
      "W-65 - Chanc Tendre",
      "W-65",
      "W65",
      "Chance Tendre",
      "Chanc Tendre",
      "Chance",
      "Tendre"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "frisch"
    ],
    "directionTerms": [
      "blumig",
      "frisch"
    ],
    "directProductTerms": [
      "W-65 - Chanc Tendre",
      "W-65",
      "W65",
      "w-65-chanc-tendre"
    ],
    "shopHandle": "w-65-chanc-tendre",
    "handle": "w-65-chanc-tendre",
    "shopCode": "W-65",
    "shopProduct": "W-65 - Chanc Tendre",
    "productUrl": "https://dieduftquelle.com/products/w-65-chanc-tendre",
    "confidence": 100,
    "direction": "blumig - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "gucci-bloom",
    "brand": "Gucci",
    "name": "Bloom",
    "variant": "",
    "searchTerms": [
      "Bloom",
      "Gucci Bloom",
      "W-54",
      "W54"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "cremig"
    ],
    "directionTerms": [
      "blumig",
      "cremig"
    ],
    "directProductTerms": [
      "Bloom",
      "W-54",
      "W54",
      "w-54-bloom"
    ],
    "shopHandle": "w-54-bloom",
    "handle": "w-54-bloom",
    "shopCode": "W-54",
    "shopProduct": "Bloom",
    "productUrl": "https://dieduftquelle.com/products/w-54-bloom",
    "confidence": 100,
    "direction": "blumig - cremig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "louis-vuitton-california-dream",
    "brand": "Louis Vuitton",
    "name": "California Dream",
    "variant": "",
    "searchTerms": [
      "California Dream",
      "Louis Vuitton California Dream",
      "Cali 4",
      "LV California Dream",
      "California",
      "Dream",
      "E-108",
      "E108"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "zitrisch"
    ],
    "directProductTerms": [
      "Cali 4",
      "E-108",
      "E108",
      "e-108-cali-dream"
    ],
    "shopHandle": "e-108-cali-dream",
    "handle": "e-108-cali-dream",
    "shopCode": "E-108",
    "shopProduct": "Cali 4",
    "productUrl": "https://dieduftquelle.com/products/e-108-cali-dream",
    "confidence": 100,
    "direction": "frisch - zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-tony-iommi-monkey-special",
    "brand": "Xerjoff",
    "name": "Tony Iommi Monkey Special",
    "variant": "",
    "searchTerms": [
      "Tony Iommi Monkey Special",
      "Xerjoff Tony Iommi Monkey Special",
      "E-102 - Monk Speciale",
      "E-102",
      "E102",
      "XJ Tony Iommi Monkey Special",
      "Monk Speciale",
      "Iommi",
      "Monkey",
      "Special"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-102 - Monk Speciale",
      "E-102",
      "E102",
      "e-102-monkey-special"
    ],
    "shopHandle": "e-102-monkey-special",
    "handle": "e-102-monkey-special",
    "shopCode": "E-102",
    "shopProduct": "E-102 - Monk Speciale",
    "productUrl": "https://dieduftquelle.com/products/e-102-monkey-special",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "jean-paul-gaultier-le-beau-paradise-garden",
    "brand": "Jean Paul Gaultier",
    "name": "Le Beau Paradise Garden",
    "variant": "",
    "searchTerms": [
      "Le Beau Paradise Garden",
      "Jean Paul Gaultier Le Beau Paradise Garden",
      "E-129 - BParadis Garden",
      "E-129",
      "E129",
      "JPG Le Beau Paradise Garden",
      "BParadis Garden",
      "Paradise",
      "Garden"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "süß"
    ],
    "directionTerms": [
      "frisch",
      "süß"
    ],
    "directProductTerms": [
      "E-129 - BParadis Garden",
      "E-129",
      "E129",
      "e-129-beau-paradis-garden"
    ],
    "shopHandle": "e-129-beau-paradis-garden",
    "handle": "e-129-beau-paradis-garden",
    "shopCode": "E-129",
    "shopProduct": "E-129 - BParadis Garden",
    "productUrl": "https://dieduftquelle.com/products/e-129-beau-paradis-garden",
    "confidence": 100,
    "direction": "frisch - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kilian-angels-share-on-the-rocks",
    "brand": "Kilian",
    "name": "Angels' Share On the Rocks",
    "variant": "",
    "searchTerms": [
      "Angels' Share On the Rocks",
      "Kilian Angels' Share On the Rocks",
      "E-131- Angel Rocks",
      "E-131",
      "E131",
      "Angel Rocks",
      "Angels",
      "Share",
      "Rocks"
    ],
    "notes": [],
    "accords": [
      "süß",
      "ztirisch"
    ],
    "directionTerms": [
      "süß",
      "ztirisch"
    ],
    "directProductTerms": [
      "E-131- Angel Rocks",
      "E-131",
      "E131",
      "e-131-angel-share-on-rocks"
    ],
    "shopHandle": "e-131-angel-share-on-rocks",
    "handle": "e-131-angel-share-on-rocks",
    "shopCode": "E-131",
    "shopProduct": "E-131- Angel Rocks",
    "productUrl": "https://dieduftquelle.com/products/e-131-angel-share-on-rocks",
    "confidence": 100,
    "direction": "süß - ztirisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "viktor-rolf-spicebomb",
    "brand": "Viktor&Rolf",
    "name": "Spicebomb",
    "variant": "",
    "searchTerms": [
      "Spicebomb",
      "Viktor&Rolf Spicebomb",
      "E-18 - Bomb Spicy",
      "E-18",
      "E18",
      "Bomb Spicy"
    ],
    "notes": [],
    "accords": [
      "würzig",
      "süß"
    ],
    "directionTerms": [
      "würzig",
      "süß"
    ],
    "directProductTerms": [
      "E-18 - Bomb Spicy",
      "E-18",
      "E18",
      "e-18-bomb-spice"
    ],
    "shopHandle": "e-18-bomb-spice",
    "handle": "e-18-bomb-spice",
    "shopCode": "E-18",
    "shopProduct": "E-18 - Bomb Spicy",
    "productUrl": "https://dieduftquelle.com/products/e-18-bomb-spice",
    "confidence": 100,
    "direction": "würzig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-bitter-peach",
    "brand": "Tom Ford",
    "name": "Bitter Peach",
    "variant": "",
    "searchTerms": [
      "Bitter Peach",
      "Tom Ford Bitter Peach",
      "E-21 - Peach",
      "E-21",
      "E21",
      "TF Bitter Peach",
      "Peach",
      "Bitter"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "süß"
    ],
    "directionTerms": [
      "fruchtig",
      "süß"
    ],
    "directProductTerms": [
      "E-21 - Peach",
      "E-21",
      "E21",
      "e-21-peach"
    ],
    "shopHandle": "e-21-peach",
    "handle": "e-21-peach",
    "shopCode": "E-21",
    "shopProduct": "E-21 - Peach",
    "productUrl": "https://dieduftquelle.com/products/e-21-peach",
    "confidence": 100,
    "direction": "fruchtig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "prada-l-homme-prada",
    "brand": "Prada",
    "name": "L'Homme Prada",
    "variant": "",
    "searchTerms": [
      "L'Homme Prada",
      "Prada L'Homme Prada",
      "E-72 - P. Lhomme",
      "E-72",
      "E72",
      "P. Lhomme",
      "Prada"
    ],
    "notes": [],
    "accords": [
      "pudrig",
      "frisch"
    ],
    "directionTerms": [
      "pudrig",
      "frisch"
    ],
    "directProductTerms": [
      "E-72 - P. Lhomme",
      "E-72",
      "E72",
      "e-72-p-l-homme"
    ],
    "shopHandle": "e-72-p-l-homme",
    "handle": "e-72-p-l-homme",
    "shopCode": "E-72",
    "shopProduct": "E-72 - P. Lhomme",
    "productUrl": "https://dieduftquelle.com/products/e-72-p-l-homme",
    "confidence": 100,
    "direction": "pudrig - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "fragrance-du-bois-oud-orange-intense",
    "brand": "Fragrance Du Bois",
    "name": "Oud Orange Intense",
    "variant": "",
    "searchTerms": [
      "Oud Orange Intense",
      "Fragrance Du Bois Oud Orange Intense",
      "E-86 - Orange Oud Intense",
      "E-86",
      "E86",
      "Orange Oud Intense",
      "Orange",
      "Intense"
    ],
    "notes": [],
    "accords": [
      "süß",
      "cremig"
    ],
    "directionTerms": [
      "süß",
      "cremig"
    ],
    "directProductTerms": [
      "E-86 - Orange Oud Intense",
      "E-86",
      "E86",
      "orange-oud-intense"
    ],
    "shopHandle": "orange-oud-intense",
    "handle": "orange-oud-intense",
    "shopCode": "E-86",
    "shopProduct": "E-86 - Orange Oud Intense",
    "productUrl": "https://dieduftquelle.com/products/orange-oud-intense",
    "confidence": 100,
    "direction": "süß - cremig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-la-capitale",
    "brand": "Xerjoff",
    "name": "La Capitale",
    "variant": "",
    "searchTerms": [
      "La Capitale",
      "Xerjoff La Capitale",
      "E-89 - El Capitale",
      "E-89",
      "E89",
      "XJ La Capitale",
      "El Capitale",
      "Capitale"
    ],
    "notes": [],
    "accords": [
      "süß",
      "fruchtig"
    ],
    "directionTerms": [
      "süß",
      "fruchtig"
    ],
    "directProductTerms": [
      "E-89 - El Capitale",
      "E-89",
      "E89",
      "e-89-el-capitale"
    ],
    "shopHandle": "e-89-el-capitale",
    "handle": "e-89-el-capitale",
    "shopCode": "E-89",
    "shopProduct": "E-89 - El Capitale",
    "productUrl": "https://dieduftquelle.com/products/e-89-el-capitale",
    "confidence": 100,
    "direction": "süß - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "escentric-molecules-molecule-01-iris",
    "brand": "Escentric Molecules",
    "name": "Molecule 01 + Iris",
    "variant": "",
    "searchTerms": [
      "Molecule 01 + Iris",
      "Escentric Molecules Molecule 01 + Iris",
      "E-95 - Mole Iris",
      "E-95",
      "E95",
      "Mole Iris",
      "Molecule"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "pudrig"
    ],
    "directionTerms": [
      "blumig",
      "pudrig"
    ],
    "directProductTerms": [
      "E-95 - Mole Iris",
      "E-95",
      "E95",
      "e-95-mole-iris"
    ],
    "shopHandle": "e-95-mole-iris",
    "handle": "e-95-mole-iris",
    "shopCode": "E-95",
    "shopProduct": "E-95 - Mole Iris",
    "productUrl": "https://dieduftquelle.com/products/e-95-mole-iris",
    "confidence": 100,
    "direction": "blumig - pudrig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "gucci-guilty-elixir-de-parfum-pour-homme",
    "brand": "Gucci",
    "name": "Guilty Elixir de Parfum pour Homme",
    "variant": "",
    "searchTerms": [
      "Guilty Elixir de Parfum pour Homme",
      "Gucci Guilty Elixir de Parfum pour Homme",
      "L- 19 Guity Elixir",
      "L-19",
      "L19",
      "Guilty",
      "Elixir"
    ],
    "notes": [
      "Ambrofix",
      "Vanillin",
      "Patchouli",
      "Siam-Benzoe",
      "Irisbutter",
      "Osmanthus",
      "Orangenblüte Absolue",
      "Muskat",
      "Piment"
    ],
    "accords": [
      "blumig",
      "süß"
    ],
    "directionTerms": [
      "blumig",
      "süß"
    ],
    "directProductTerms": [
      "L- 19 Guity Elixir",
      "L-19",
      "L19",
      "l-19-guity-elixir"
    ],
    "shopHandle": "l-19-guity-elixir",
    "handle": "l-19-guity-elixir",
    "shopCode": "L-19",
    "shopProduct": "L- 19 Guity Elixir",
    "productUrl": "https://dieduftquelle.com/products/l-19-guity-elixir",
    "confidence": 100,
    "direction": "blumig - süß",
    "topNotes": "Ambrofix, Vanillin, Patchouli, Siam-Benzoe",
    "heartNotes": "Irisbutter, Osmanthus",
    "baseNotes": "Orangenblüte Absolue, Muskat, Piment"
  },
  {
    "id": "tom-ford-lost-cherry",
    "brand": "Tom Ford",
    "name": "Lost Cherry",
    "variant": "",
    "searchTerms": [
      "Lost Cherry",
      "Tom Ford Lost Cherry",
      "L- 36 - Rud Cherry",
      "L-36",
      "L36",
      "TF Lost Cherry",
      "Cherry"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "süß"
    ],
    "directionTerms": [
      "holzig",
      "süß"
    ],
    "directProductTerms": [
      "L- 36 - Rud Cherry",
      "L-36",
      "L36",
      "l-36-rud-cherry"
    ],
    "shopHandle": "l-36-rud-cherry",
    "handle": "l-36-rud-cherry",
    "shopCode": "L-36",
    "shopProduct": "L- 36 - Rud Cherry",
    "productUrl": "https://dieduftquelle.com/products/l-36-rud-cherry",
    "confidence": 100,
    "direction": "holzig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "hugo-boss-boss-bottled-absolu",
    "brand": "Hugo Boss",
    "name": "Boss Bottled Absolu",
    "variant": "",
    "searchTerms": [
      "Boss Bottled Absolu",
      "Hugo Boss Boss Bottled Absolu",
      "L- 54 Bottle Absolut",
      "L-54",
      "L54",
      "Bottled",
      "Absolu"
    ],
    "notes": [
      "Leder",
      "Weihrauch",
      "Patchouli",
      "Myrrhe",
      "Davana",
      "Zedernholz"
    ],
    "accords": [
      "würzig",
      "süß"
    ],
    "directionTerms": [
      "würzig",
      "süß"
    ],
    "directProductTerms": [
      "L- 54 Bottle Absolut",
      "L-54",
      "L54",
      "l-54-bottle-absolut"
    ],
    "shopHandle": "l-54-bottle-absolut",
    "handle": "l-54-bottle-absolut",
    "shopCode": "L-54",
    "shopProduct": "L- 54 Bottle Absolut",
    "productUrl": "https://dieduftquelle.com/products/l-54-bottle-absolut",
    "confidence": 100,
    "direction": "würzig - süß",
    "topNotes": "Leder, Weihrauch",
    "heartNotes": "Patchouli, Myrrhe",
    "baseNotes": "Davana, Zedernholz"
  },
  {
    "id": "matiere-premiere-vanilla-powder",
    "brand": "Matière Première",
    "name": "Vanilla Powder",
    "variant": "",
    "searchTerms": [
      "Vanilla Powder",
      "Matière Première Vanilla Powder",
      "L-40 - Vanilla Power",
      "L-40",
      "L40",
      "Matiere Premiere Vanilla Powder",
      "Vanilla Power",
      "Vanilla",
      "Powder"
    ],
    "notes": [],
    "accords": [
      "süß",
      "cremig"
    ],
    "directionTerms": [
      "süß",
      "cremig"
    ],
    "directProductTerms": [
      "L-40 - Vanilla Power",
      "L-40",
      "L40",
      "l-40-vanilla-poudre"
    ],
    "shopHandle": "l-40-vanilla-poudre",
    "handle": "l-40-vanilla-poudre",
    "shopCode": "L-40",
    "shopProduct": "L-40 - Vanilla Power",
    "productUrl": "https://dieduftquelle.com/products/l-40-vanilla-poudre",
    "confidence": 100,
    "direction": "süß - cremig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "rochas-rochas-man",
    "brand": "Rochas",
    "name": "Rochas Man",
    "variant": "",
    "searchTerms": [
      "Rochas Man",
      "Rochas Rochas Man",
      "M-15 - Rohjas M",
      "M-15",
      "M15",
      "Rohjas M",
      "Rochas"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "M-15 - Rohjas M",
      "M-15",
      "M15",
      "m-15-roschas-man"
    ],
    "shopHandle": "m-15-roschas-man",
    "handle": "m-15-roschas-man",
    "shopCode": "M-15",
    "shopProduct": "M-15 - Rohjas M",
    "productUrl": "https://dieduftquelle.com/products/m-15-roschas-man",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "nikos-sculpture-homme",
    "brand": "Nikos",
    "name": "Sculpture Homme",
    "variant": "",
    "searchTerms": [
      "Sculpture Homme",
      "Nikos Sculpture Homme",
      "M-16 - Sculptore",
      "M-16",
      "M16",
      "Sculptore",
      "Sculpture"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "süß"
    ],
    "directionTerms": [
      "frisch",
      "süß"
    ],
    "directProductTerms": [
      "M-16 - Sculptore",
      "M-16",
      "M16",
      "m-16-scupltur"
    ],
    "shopHandle": "m-16-scupltur",
    "handle": "m-16-scupltur",
    "shopCode": "M-16",
    "shopProduct": "M-16 - Sculptore",
    "productUrl": "https://dieduftquelle.com/products/m-16-scupltur",
    "confidence": 100,
    "direction": "frisch - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "valentino-uomo",
    "brand": "Valentino",
    "name": "Uomo",
    "variant": "",
    "searchTerms": [
      "Uomo",
      "Valentino Uomo",
      "M-23 - Umo",
      "M-23",
      "M23",
      "Umo"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "M-23 - Umo",
      "M-23",
      "M23",
      "m-24-valen-uomo"
    ],
    "shopHandle": "m-24-valen-uomo",
    "handle": "m-24-valen-uomo",
    "shopCode": "M-23",
    "shopProduct": "M-23 - Umo",
    "productUrl": "https://dieduftquelle.com/products/m-24-valen-uomo",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "creed-silver-mountain-water",
    "brand": "Creed",
    "name": "Silver Mountain Water",
    "variant": "",
    "searchTerms": [
      "Silver Mountain Water",
      "Creed Silver Mountain Water",
      "M-5 - Silver Mountain",
      "M-5",
      "M5",
      "Silver Mountain",
      "Silver",
      "Mountain",
      "Water"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "zitrisch"
    ],
    "directProductTerms": [
      "M-5 - Silver Mountain",
      "M-5",
      "M5",
      "l-e-mal-parfum-kopie"
    ],
    "shopHandle": "l-e-mal-parfum-kopie",
    "handle": "l-e-mal-parfum-kopie",
    "shopCode": "M-5",
    "shopProduct": "M-5 - Silver Mountain",
    "productUrl": "https://dieduftquelle.com/products/l-e-mal-parfum-kopie",
    "confidence": 100,
    "direction": "frisch - zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "narciso-rodriguez-musc-noir",
    "brand": "Narciso Rodriguez",
    "name": "Musc Noir",
    "variant": "",
    "searchTerms": [
      "Musc Noir",
      "Narciso Rodriguez Musc Noir",
      "Musk Noir",
      "NR Musc Noir",
      "E-109",
      "E109"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "blumig"
    ],
    "directionTerms": [
      "fruchtig",
      "blumig"
    ],
    "directProductTerms": [
      "Musk Noir",
      "E-109",
      "E109",
      "e-109-musk-noir"
    ],
    "shopHandle": "e-109-musk-noir",
    "handle": "e-109-musk-noir",
    "shopCode": "E-109",
    "shopProduct": "Musk Noir",
    "productUrl": "https://dieduftquelle.com/products/e-109-musk-noir",
    "confidence": 100,
    "direction": "fruchtig - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "louis-vuitton-afternoon-swim",
    "brand": "Louis Vuitton",
    "name": "Afternoon Swim",
    "variant": "",
    "searchTerms": [
      "Afternoon Swim",
      "Louis Vuitton Afternoon Swim",
      "Swimming Splash",
      "LV Afternoon Swim",
      "Afternoon",
      "E-40",
      "E40"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "zitrisch"
    ],
    "directProductTerms": [
      "Swimming Splash",
      "E-40",
      "E40",
      "e-40-after-swim"
    ],
    "shopHandle": "e-40-after-swim",
    "handle": "e-40-after-swim",
    "shopCode": "E-40",
    "shopProduct": "Swimming Splash",
    "productUrl": "https://dieduftquelle.com/products/e-40-after-swim",
    "confidence": 100,
    "direction": "frisch - zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "narciso-rodriguez-pure-musc-for-her",
    "brand": "Narciso Rodriguez",
    "name": "Pure Musc for Her",
    "variant": "",
    "searchTerms": [
      "Pure Musc for Her",
      "Narciso Rodriguez Pure Musc for Her",
      "W-14 - Pure Musk",
      "W-14",
      "W14",
      "NR Pure Musc for Her",
      "Pure Musk"
    ],
    "notes": [],
    "accords": [
      "cremig",
      "blumig"
    ],
    "directionTerms": [
      "cremig",
      "blumig"
    ],
    "directProductTerms": [
      "W-14 - Pure Musk",
      "W-14",
      "W14",
      "w-14-pure-musk"
    ],
    "shopHandle": "w-14-pure-musk",
    "handle": "w-14-pure-musk",
    "shopCode": "W-14",
    "shopProduct": "W-14 - Pure Musk",
    "productUrl": "https://dieduftquelle.com/products/w-14-pure-musk",
    "confidence": 100,
    "direction": "cremig - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "chloe-chloe-eau-de-parfum",
    "brand": "Chloé",
    "name": "Chloé Eau de Parfum",
    "variant": "",
    "searchTerms": [
      "Chloé Eau de Parfum",
      "Chloé Chloé Eau de Parfum",
      "W-40 - Cloe",
      "W-40",
      "W40",
      "Chloe Eau de Parfum",
      "Chloe Chloe Eau de Parfum",
      "Cloe",
      "Chloé"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "frisch"
    ],
    "directionTerms": [
      "blumig",
      "frisch"
    ],
    "directProductTerms": [
      "W-40 - Cloe",
      "W-40",
      "W40",
      "w-40-cloe"
    ],
    "shopHandle": "w-40-cloe",
    "handle": "w-40-cloe",
    "shopCode": "W-40",
    "shopProduct": "W-40 - Cloe",
    "productUrl": "https://dieduftquelle.com/products/w-40-cloe",
    "confidence": 100,
    "direction": "blumig - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "gucci-flora",
    "brand": "Gucci",
    "name": "Flora",
    "variant": "",
    "searchTerms": [
      "Flora",
      "Gucci Flora",
      "W-55 - Flora",
      "W-55",
      "W55"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "süß"
    ],
    "directionTerms": [
      "blumig",
      "süß"
    ],
    "directProductTerms": [
      "W-55 - Flora",
      "W-55",
      "W55",
      "w-55-flora"
    ],
    "shopHandle": "w-55-flora",
    "handle": "w-55-flora",
    "shopCode": "W-55",
    "shopProduct": "W-55 - Flora",
    "productUrl": "https://dieduftquelle.com/products/w-55-flora",
    "confidence": 100,
    "direction": "blumig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "bvlgari-omnia-crystalline",
    "brand": "Bvlgari",
    "name": "Omnia Crystalline",
    "variant": "",
    "searchTerms": [
      "Omnia Crystalline",
      "Bvlgari Omnia Crystalline",
      "W-56 - Crystalline",
      "W-56",
      "W56",
      "Bulgari Omnia Crystalline",
      "Crystalline",
      "Omnia"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "blumig"
    ],
    "directionTerms": [
      "frisch",
      "blumig"
    ],
    "directProductTerms": [
      "W-56 - Crystalline",
      "W-56",
      "W56",
      "w-56-crystalline"
    ],
    "shopHandle": "w-56-crystalline",
    "handle": "w-56-crystalline",
    "shopCode": "W-56",
    "shopProduct": "W-56 - Crystalline",
    "productUrl": "https://dieduftquelle.com/products/w-56-crystalline",
    "confidence": 100,
    "direction": "frisch - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dolce-gabbana-light-blue-forever",
    "brand": "Dolce & Gabbana",
    "name": "Light Blue Forever",
    "variant": "",
    "searchTerms": [
      "Light Blue Forever",
      "Dolce & Gabbana Light Blue Forever",
      "W-61 - Light Bl. forever",
      "W-61",
      "W61",
      "D&G Light Blue Forever",
      "Dolce Gabbana Light Blue Forever",
      "Light Bl. forever",
      "Light",
      "Forever"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "Zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "Zitrisch"
    ],
    "directProductTerms": [
      "W-61 - Light Bl. forever",
      "W-61",
      "W61",
      "w-61-light-bl-forever"
    ],
    "shopHandle": "w-61-light-bl-forever",
    "handle": "w-61-light-bl-forever",
    "shopCode": "W-61",
    "shopProduct": "W-61 - Light Bl. forever",
    "productUrl": "https://dieduftquelle.com/products/w-61-light-bl-forever",
    "confidence": 100,
    "direction": "frisch - Zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "viktor-rolf-flowerbomb",
    "brand": "Viktor&Rolf",
    "name": "Flowerbomb",
    "variant": "",
    "searchTerms": [
      "Flowerbomb",
      "Viktor&Rolf Flowerbomb",
      "W-8 - Bomb Flower",
      "W-8",
      "W8",
      "Bomb Flower"
    ],
    "notes": [],
    "accords": [
      "süß",
      "blumig"
    ],
    "directionTerms": [
      "süß",
      "blumig"
    ],
    "directProductTerms": [
      "W-8 - Bomb Flower",
      "W-8",
      "W8",
      "w-7-bomb-flower"
    ],
    "shopHandle": "w-7-bomb-flower",
    "handle": "w-7-bomb-flower",
    "shopCode": "W-8",
    "shopProduct": "W-8 - Bomb Flower",
    "productUrl": "https://dieduftquelle.com/products/w-7-bomb-flower",
    "confidence": 100,
    "direction": "süß - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "emporio-armani-stronger-with-you-powerfully",
    "brand": "Emporio Armani",
    "name": "Stronger With You Powerfully",
    "variant": "",
    "searchTerms": [
      "Stronger With You Powerfully",
      "Emporio Armani Stronger With You Powerfully",
      "L-7 - Strong you Power",
      "L-7",
      "L7",
      "Strong you Power",
      "Stronger",
      "Powerfully"
    ],
    "notes": [
      "Kirsche",
      "Mandarine",
      "Gewürze",
      "Diva-Lavendel",
      "Kastanie",
      "Vanille",
      "Amberholz"
    ],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "L-7 - Strong you Power",
      "L-7",
      "L7",
      "l-7-strong-you-power"
    ],
    "shopHandle": "l-7-strong-you-power",
    "handle": "l-7-strong-you-power",
    "shopCode": "L-7",
    "shopProduct": "L-7 - Strong you Power",
    "productUrl": "https://dieduftquelle.com/products/l-7-strong-you-power",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "Kirsche, Mandarine",
    "heartNotes": "Gewürze, Diva-Lavendel",
    "baseNotes": "Kastanie, Vanille, Amberholz"
  },
  {
    "id": "chanel-chance",
    "brand": "Chanel",
    "name": "Chance",
    "variant": "",
    "searchTerms": [
      "Chance",
      "Chanel Chance",
      "W-25 - Chanc",
      "W-25",
      "W25",
      "Chanc"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "frisch"
    ],
    "directionTerms": [
      "blumig",
      "frisch"
    ],
    "directProductTerms": [
      "W-25 - Chanc",
      "W-25",
      "W25",
      "w-25-canse"
    ],
    "shopHandle": "w-25-canse",
    "handle": "w-25-canse",
    "shopCode": "W-25",
    "shopProduct": "W-25 - Chanc",
    "productUrl": "https://dieduftquelle.com/products/w-25-canse",
    "confidence": 100,
    "direction": "blumig - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kilian-good-girl-gone-bad",
    "brand": "Kilian",
    "name": "Good Girl Gone Bad",
    "variant": "",
    "searchTerms": [
      "Good Girl Gone Bad",
      "Kilian Good Girl Gone Bad",
      "Bad Girl",
      "W-28",
      "W28"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "süß"
    ],
    "directionTerms": [
      "blumig",
      "süß"
    ],
    "directProductTerms": [
      "Bad Girl",
      "W-28",
      "W28",
      "w-27-god-girl-g-bad"
    ],
    "shopHandle": "w-27-god-girl-g-bad",
    "handle": "w-27-god-girl-g-bad",
    "shopCode": "W-28",
    "shopProduct": "Bad Girl",
    "productUrl": "https://dieduftquelle.com/products/w-27-god-girl-g-bad",
    "confidence": 100,
    "direction": "blumig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-vanilla-sex",
    "brand": "Tom Ford",
    "name": "Vanilla Sex",
    "variant": "",
    "searchTerms": [
      "Vanilla Sex",
      "E-117 - Vanilla S..",
      "Vanilla",
      "Tom Ford Vanilla Sex",
      "E-117",
      "E117"
    ],
    "notes": [],
    "accords": [
      "süß",
      "cremig"
    ],
    "directionTerms": [
      "süß",
      "cremig"
    ],
    "directProductTerms": [
      "E-117 - Vanilla S..",
      "E-117",
      "E117",
      "e-117-vanilla-s"
    ],
    "shopHandle": "e-117-vanilla-s",
    "handle": "e-117-vanilla-s",
    "shopCode": "E-117",
    "shopProduct": "E-117 - Vanilla S..",
    "productUrl": "https://dieduftquelle.com/products/e-117-vanilla-s",
    "confidence": 100,
    "direction": "süß - cremig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dior-diorama",
    "brand": "Dior",
    "name": "Diorama",
    "variant": "",
    "searchTerms": [
      "Diorama",
      "Dior Dioramar",
      "E-125 - Diorama",
      "E-125",
      "E125",
      "Dior Diorama",
      "E-125 - Dioromer"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-125 - Dioromer",
      "E-125",
      "E125",
      "e-125-dioramer"
    ],
    "shopHandle": "e-125-dioramer",
    "handle": "e-125-dioramer",
    "shopCode": "E-125",
    "shopProduct": "E-125 - Dioromer",
    "productUrl": "https://dieduftquelle.com/products/e-125-dioramer",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "widian-london",
    "brand": "Widian",
    "name": "London",
    "variant": "",
    "searchTerms": [
      "London",
      "Widian London",
      "E-54 - W. London",
      "E-54",
      "E54",
      "W. London"
    ],
    "notes": [],
    "accords": [
      "ledrig",
      "fruchtig"
    ],
    "directionTerms": [
      "ledrig",
      "fruchtig"
    ],
    "directProductTerms": [
      "E-54 - W. London",
      "E-54",
      "E54",
      "e-54-w-london"
    ],
    "shopHandle": "e-54-w-london",
    "handle": "e-54-w-london",
    "shopCode": "E-54",
    "shopProduct": "E-54 - W. London",
    "productUrl": "https://dieduftquelle.com/products/e-54-w-london",
    "confidence": 100,
    "direction": "ledrig - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "montale-arabians-tonka",
    "brand": "Montale",
    "name": "Arabians Tonka",
    "variant": "",
    "searchTerms": [
      "Arabians Tonka",
      "Montale Arabians Tonka",
      "E-70 - Arabians",
      "E-70",
      "E70",
      "Arabians",
      "Tonka"
    ],
    "notes": [],
    "accords": [
      "orientalisch",
      "süß"
    ],
    "directionTerms": [
      "orientalisch",
      "süß"
    ],
    "directProductTerms": [
      "E-70 - Arabians",
      "E-70",
      "E70"
    ],
    "shopHandle": "e-70",
    "handle": "e-70",
    "shopCode": "E-70",
    "shopProduct": "E-70 - Arabians",
    "productUrl": "https://dieduftquelle.com/products/e-70",
    "confidence": 100,
    "direction": "orientalisch - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "nasomatto-baraonda",
    "brand": "Nasomatto",
    "name": "Baraonda",
    "variant": "",
    "searchTerms": [
      "Baraonda",
      "Nasomatto Baraonda",
      "E-90 - Baradano",
      "E-90",
      "E90",
      "Baradano"
    ],
    "notes": [],
    "accords": [
      "würzig",
      "holzig"
    ],
    "directionTerms": [
      "würzig",
      "holzig"
    ],
    "directProductTerms": [
      "E-90 - Baradano",
      "E-90",
      "E90"
    ],
    "shopHandle": "e-90",
    "handle": "e-90",
    "shopCode": "E-90",
    "shopProduct": "E-90 - Baradano",
    "productUrl": "https://dieduftquelle.com/products/e-90",
    "confidence": 100,
    "direction": "würzig - holzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kayali-yum-pistachio-gelato-33",
    "brand": "Kayali",
    "name": "Yum Pistachio Gelato 33",
    "variant": "",
    "searchTerms": [
      "Yum Pistachio Gelato 33",
      "Kayali Yum Pistachio Gelato 33",
      "L-14 - Pistachio",
      "L-14",
      "L14",
      "Pistachio",
      "Gelato"
    ],
    "notes": [],
    "accords": [
      "süß",
      "cremig"
    ],
    "directionTerms": [
      "süß",
      "cremig"
    ],
    "directProductTerms": [
      "L-14 - Pistachio",
      "L-14",
      "L14",
      "l-14-pistachio"
    ],
    "shopHandle": "l-14-pistachio",
    "handle": "l-14-pistachio",
    "shopCode": "L-14",
    "shopProduct": "L-14 - Pistachio",
    "productUrl": "https://dieduftquelle.com/products/l-14-pistachio",
    "confidence": 100,
    "direction": "süß - cremig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kenzo-kenzo-pour-homme",
    "brand": "Kenzo",
    "name": "Kenzo pour Homme",
    "variant": "",
    "searchTerms": [
      "Kenzo pour Homme",
      "Kenzo Kenzo pour Homme",
      "M-14 - K. Pour Homme",
      "M-14",
      "M14",
      "K. Pour Homme",
      "Kenzo"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "aquatisch"
    ],
    "directionTerms": [
      "frisch",
      "aquatisch"
    ],
    "directProductTerms": [
      "M-14 - K. Pour Homme",
      "M-14",
      "M14",
      "m-14-k-pour-homme"
    ],
    "shopHandle": "m-14-k-pour-homme",
    "handle": "m-14-k-pour-homme",
    "shopCode": "M-14",
    "shopProduct": "M-14 - K. Pour Homme",
    "productUrl": "https://dieduftquelle.com/products/m-14-k-pour-homme",
    "confidence": 100,
    "direction": "frisch - aquatisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "narciso-rodriguez-for-her",
    "brand": "Narciso Rodriguez",
    "name": "For Her",
    "variant": "",
    "searchTerms": [
      "For Her",
      "Narciso Rodriguez For Her",
      "W-13 - Narzisco Woman",
      "W-13",
      "W13",
      "NR For Her",
      "Narzisco Woman"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "pudrig"
    ],
    "directionTerms": [
      "blumig",
      "pudrig"
    ],
    "directProductTerms": [
      "W-13 - Narzisco Woman",
      "W-13",
      "W13",
      "w-13-nr-for-women"
    ],
    "shopHandle": "w-13-nr-for-women",
    "handle": "w-13-nr-for-women",
    "shopCode": "W-13",
    "shopProduct": "W-13 - Narzisco Woman",
    "productUrl": "https://dieduftquelle.com/products/w-13-nr-for-women",
    "confidence": 100,
    "direction": "blumig - pudrig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-lost-cherry",
    "brand": "Tom Ford",
    "name": "Lost Cherry",
    "variant": "",
    "searchTerms": [
      "Lost Cherry",
      "Tom Ford Lost Cherry",
      "E-7 - Cherry",
      "E-7",
      "E7",
      "TF Lost Cherry",
      "Cherry"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "süß"
    ],
    "directionTerms": [
      "fruchtig",
      "süß"
    ],
    "directProductTerms": [
      "E-7 - Cherry",
      "E-7",
      "E7",
      "e-7-cherry"
    ],
    "shopHandle": "e-7-cherry",
    "handle": "e-7-cherry",
    "shopCode": "E-7",
    "shopProduct": "E-7 - Cherry",
    "productUrl": "https://dieduftquelle.com/products/e-7-cherry",
    "confidence": 100,
    "direction": "fruchtig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "diptyque-kyoto",
    "brand": "Diptyque",
    "name": "Kyoto",
    "variant": "",
    "searchTerms": [
      "Kyoto",
      "Diptyque Kyoto",
      "Comme des Garcons Kyoto",
      "E-93",
      "E93"
    ],
    "notes": [],
    "accords": [
      "grün",
      "erdig"
    ],
    "directionTerms": [
      "grün",
      "erdig"
    ],
    "directProductTerms": [
      "Kyoto",
      "E-93",
      "E93",
      "e-93-kyoto"
    ],
    "shopHandle": "e-93-kyoto",
    "handle": "e-93-kyoto",
    "shopCode": "E-93",
    "shopProduct": "Kyoto",
    "productUrl": "https://dieduftquelle.com/products/e-93-kyoto",
    "confidence": 100,
    "direction": "grün - erdig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-cherry-smoke",
    "brand": "Tom Ford",
    "name": "Cherry Smoke",
    "variant": "",
    "searchTerms": [
      "Cherry Smoke",
      "Tom Ford Cherry Smoke",
      "E-88",
      "Smoke",
      "E-88 - Smoking Cherry",
      "E88"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "rauchig"
    ],
    "directionTerms": [
      "fruchtig",
      "rauchig"
    ],
    "directProductTerms": [
      "E-88 - Smoking Cherry",
      "E-88",
      "E88",
      "e-88-smoking-cherry"
    ],
    "shopHandle": "e-88-smoking-cherry",
    "handle": "e-88-smoking-cherry",
    "shopCode": "E-88",
    "shopProduct": "E-88 - Smoking Cherry",
    "productUrl": "https://dieduftquelle.com/products/e-88-smoking-cherry",
    "confidence": 100,
    "direction": "fruchtig - rauchig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dieduftquelle-erba-pura-baccarat-rouge",
    "brand": "DieDuftQuelle",
    "name": "Erba Pura / Baccarat Rouge",
    "variant": "",
    "searchTerms": [
      "Erba Gold / Erba Pura style",
      "Xerjoff Erba Gold / Erba Pura style",
      "Erba Rouge",
      "XJ Erba Gold / Erba Pura style",
      "style, bacccarat Rouge",
      "Erba Pura / Baccarat Rouge",
      "DieDuftQuelle Erba Pura / Baccarat Rouge",
      "L-20",
      "L20"
    ],
    "notes": [],
    "accords": [
      "süß",
      "holzig"
    ],
    "directionTerms": [
      "süß",
      "holzig"
    ],
    "directProductTerms": [
      "Erba Rouge",
      "L-20",
      "L20",
      "l-20-erba-rouge"
    ],
    "shopHandle": "l-20-erba-rouge",
    "handle": "l-20-erba-rouge",
    "shopCode": "L-20",
    "shopProduct": "Erba Rouge",
    "productUrl": "https://dieduftquelle.com/products/l-20-erba-rouge",
    "confidence": 100,
    "direction": "süß - holzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "guerlain-tonka-imperiale",
    "brand": "Guerlain",
    "name": "Tonka Imperiale",
    "variant": "",
    "searchTerms": [
      "Tonka Imeperiale Guerlain",
      "Guerlain",
      "Tonka Imperiale",
      "Tonka",
      "E-85",
      "Guerlain Tonka Imperiale",
      "E-85 - Imperial Tonka",
      "E85"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "E-85 - Imperial Tonka",
      "E-85",
      "E85",
      "e-85-imperial-tonka"
    ],
    "shopHandle": "e-85-imperial-tonka",
    "handle": "e-85-imperial-tonka",
    "shopCode": "E-85",
    "shopProduct": "E-85 - Imperial Tonka",
    "productUrl": "https://dieduftquelle.com/products/e-85-imperial-tonka",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "initio-blessed-baraka",
    "brand": "Initio",
    "name": "Blessed Baraka",
    "variant": "",
    "searchTerms": [
      "Baraka",
      "Initio Blessed Baraka",
      "E-101 Baraka",
      "E-101",
      "E101",
      "Guerlain",
      "style",
      "Blessed Baraka"
    ],
    "notes": [],
    "accords": [
      "süß",
      "holzig"
    ],
    "directionTerms": [
      "süß",
      "holzig"
    ],
    "directProductTerms": [
      "E-101 Baraka",
      "E-101",
      "E101",
      "e-101-baraka"
    ],
    "shopHandle": "e-101-baraka",
    "handle": "e-101-baraka",
    "shopCode": "E-101",
    "shopProduct": "E-101 Baraka",
    "productUrl": "https://dieduftquelle.com/products/e-101-baraka",
    "confidence": 100,
    "direction": "süß-holzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-noir-extreme",
    "brand": "Tom Ford",
    "name": "Noir Extreme",
    "variant": "",
    "searchTerms": [
      "Tom Ford",
      "Tom Ford Noir Extreme",
      "Noir Extreme",
      "Extreme",
      "E-5",
      "NExtreme",
      "E5"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "NExtreme",
      "E-5",
      "E5",
      "e-5-n-extrem"
    ],
    "shopHandle": "e-5-n-extrem",
    "handle": "e-5-n-extrem",
    "shopCode": "E-5",
    "shopProduct": "NExtreme",
    "productUrl": "https://dieduftquelle.com/products/e-5-n-extrem",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dior-addict",
    "brand": "Dior",
    "name": "Addict",
    "variant": "",
    "searchTerms": [
      "Addict",
      "Dior Addict",
      "W-44",
      "W44"
    ],
    "notes": [],
    "accords": [
      "süß",
      "blumig"
    ],
    "directionTerms": [
      "süß",
      "blumig"
    ],
    "directProductTerms": [
      "Addict",
      "W-44",
      "W44"
    ],
    "shopHandle": "addict",
    "handle": "addict",
    "shopCode": "W-44",
    "shopProduct": "Addict",
    "productUrl": "https://dieduftquelle.com/products/addict",
    "confidence": 100,
    "direction": "süß - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-black-lacquer",
    "brand": "Tom Ford",
    "name": "Black Lacquer",
    "variant": "",
    "searchTerms": [
      "Black Lacquer",
      "Tom Ford Black Lacquer",
      "B. Lacquer",
      "TF Black Lacquer",
      "Black",
      "Lacquer",
      "L-22",
      "L22"
    ],
    "notes": [],
    "accords": [
      "rauchig",
      "würzig"
    ],
    "directionTerms": [
      "rauchig",
      "würzig"
    ],
    "directProductTerms": [
      "B. Lacquer",
      "L-22",
      "L22",
      "l-22-b-lacquer"
    ],
    "shopHandle": "l-22-b-lacquer",
    "handle": "l-22-b-lacquer",
    "shopCode": "L-22",
    "shopProduct": "B. Lacquer",
    "productUrl": "https://dieduftquelle.com/products/l-22-b-lacquer",
    "confidence": 100,
    "direction": "rauchig - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kilian-back-to-black",
    "brand": "Kilian",
    "name": "Back to Black",
    "variant": "",
    "searchTerms": [
      "Back to Black",
      "Kilian Back to Black",
      "B2 Black",
      "Black",
      "M-40",
      "M40"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "B2 Black",
      "M-40",
      "M40",
      "m-40-back-2-black"
    ],
    "shopHandle": "m-40-back-2-black",
    "handle": "m-40-back-2-black",
    "shopCode": "M-40",
    "shopProduct": "B2 Black",
    "productUrl": "https://dieduftquelle.com/products/m-40-back-2-black",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "louis-vuitton-pacific-chill",
    "brand": "Louis Vuitton",
    "name": "Pacific Chill",
    "variant": "",
    "searchTerms": [
      "Pacific Chill",
      "Louis Vuitton Pacific Chill",
      "Chillos",
      "LV Pacific Chill",
      "Pacific",
      "Chill",
      "E-110",
      "E110"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "frisch"
    ],
    "directionTerms": [
      "fruchtig",
      "frisch"
    ],
    "directProductTerms": [
      "Chillos",
      "E-110",
      "E110",
      "e-110-pac-chill"
    ],
    "shopHandle": "e-110-pac-chill",
    "handle": "e-110-pac-chill",
    "shopCode": "E-110",
    "shopProduct": "Chillos",
    "productUrl": "https://dieduftquelle.com/products/e-110-pac-chill",
    "confidence": 100,
    "direction": "fruchtig - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dieduftquelle-clean-woman-touch-flowers",
    "brand": "DieDuftQuelle",
    "name": "Clean Woman Touch Flowers",
    "variant": "",
    "searchTerms": [
      "Clean Woman Touch Flowers",
      "DieDuftQuelle Clean Woman Touch Flowers",
      "Clean Women touch Flowers",
      "Clean",
      "Touch",
      "Flowers",
      "L-38",
      "L38"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "blumig"
    ],
    "directionTerms": [
      "frisch",
      "blumig"
    ],
    "directProductTerms": [
      "Clean Women touch Flowers",
      "L-38",
      "L38",
      "clean-women-touch-flowers"
    ],
    "shopHandle": "clean-women-touch-flowers",
    "handle": "clean-women-touch-flowers",
    "shopCode": "L-38",
    "shopProduct": "Clean Women touch Flowers",
    "productUrl": "https://dieduftquelle.com/products/clean-women-touch-flowers",
    "confidence": 100,
    "direction": "frisch - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "louis-vuitton-ombre-nomade",
    "brand": "Louis Vuitton",
    "name": "Ombre Nomade",
    "variant": "",
    "searchTerms": [
      "Ombre Nomade",
      "Louis Vuitton Ombre Nomade",
      "Dark Raspberry",
      "LV Ombre Nomade",
      "Ombré Nomade",
      "Ombre",
      "Nomade",
      "E-1",
      "E1"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "rauchig"
    ],
    "directionTerms": [
      "holzig",
      "rauchig"
    ],
    "directProductTerms": [
      "Dark Raspberry",
      "E-1",
      "E1",
      "dark-raspberry"
    ],
    "shopHandle": "dark-raspberry",
    "handle": "dark-raspberry",
    "shopCode": "E-1",
    "shopProduct": "Dark Raspberry",
    "productUrl": "https://dieduftquelle.com/products/dark-raspberry",
    "confidence": 100,
    "direction": "holzig - rauchig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dieduftquelle-della",
    "brand": "DieDuftQuelle",
    "name": "Della",
    "variant": "",
    "searchTerms": [
      "Della",
      "DieDuftQuelle Della",
      "E-122",
      "E122"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "süß"
    ],
    "directionTerms": [
      "blumig",
      "süß"
    ],
    "directProductTerms": [
      "Della",
      "E-122",
      "E122"
    ],
    "shopHandle": "della",
    "handle": "della",
    "shopCode": "E-122",
    "shopProduct": "Della",
    "productUrl": "https://dieduftquelle.com/products/della",
    "confidence": 100,
    "direction": "blumig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "parfums-de-marly-layton",
    "brand": "Parfums de Marly",
    "name": "Layton",
    "variant": "",
    "searchTerms": [
      "Layton",
      "Parfums de Marly Layton",
      "E-10 - Ayton",
      "E-10",
      "E10",
      "PDM Layton",
      "Parfum de Marly Layton",
      "Ayton"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-10 - Ayton",
      "E-10",
      "E10"
    ],
    "shopHandle": "e-10",
    "handle": "e-10",
    "shopCode": "E-10",
    "shopProduct": "E-10 - Ayton",
    "productUrl": "https://dieduftquelle.com/products/e-10",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "parfums-de-marly-althair",
    "brand": "Parfums de Marly",
    "name": "Althaïr",
    "variant": "",
    "searchTerms": [
      "Althaïr",
      "Parfums de Marly Althaïr",
      "E-100 - Alter",
      "E-100",
      "E100",
      "PDM Althaïr",
      "Parfum de Marly Althaïr",
      "Althair",
      "Parfums de Marly Althair",
      "PDM Althair",
      "Parfum de Marly Althair",
      "Alter"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "E-100 - Alter",
      "E-100",
      "E100",
      "e-100-alter"
    ],
    "shopHandle": "e-100-alter",
    "handle": "e-100-alter",
    "shopCode": "E-100",
    "shopProduct": "E-100 - Alter",
    "productUrl": "https://dieduftquelle.com/products/e-100-alter",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "bdk-parfums-gris-charnel",
    "brand": "BDK Parfums",
    "name": "Gris Charnel",
    "variant": "",
    "searchTerms": [
      "Gris Charnel",
      "BDK Parfums Gris Charnel",
      "E-104 - Gri Charjel",
      "E-104",
      "E104",
      "Gri Charjel",
      "Charnel"
    ],
    "notes": [],
    "accords": [
      "cremig",
      "würzig"
    ],
    "directionTerms": [
      "cremig",
      "würzig"
    ],
    "directProductTerms": [
      "E-104 - Gri Charjel",
      "E-104",
      "E104",
      "e"
    ],
    "shopHandle": "e",
    "handle": "e",
    "shopCode": "E-104",
    "shopProduct": "E-104 - Gri Charjel",
    "productUrl": "https://dieduftquelle.com/products/e",
    "confidence": 100,
    "direction": "cremig - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "clive-christian-blonde-amber",
    "brand": "Clive Christian",
    "name": "Blonde Amber",
    "variant": "",
    "searchTerms": [
      "Blonde Amber",
      "Clive Christian Blonde Amber",
      "E-113 - Blounded Amber",
      "E-113",
      "E113",
      "C. Christian Blonde Amber",
      "Blounded Amber",
      "Blonde",
      "Amber"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-113 - Blounded Amber",
      "E-113",
      "E113",
      "l-113-bl-amber"
    ],
    "shopHandle": "l-113-bl-amber",
    "handle": "l-113-bl-amber",
    "shopCode": "E-113",
    "shopProduct": "E-113 - Blounded Amber",
    "productUrl": "https://dieduftquelle.com/products/l-113-bl-amber",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kilian-roses-on-ice",
    "brand": "Kilian",
    "name": "Roses on Ice",
    "variant": "",
    "searchTerms": [
      "Roses on Ice",
      "Kilian Roses on Ice",
      "E-126 - Roses Ice",
      "E-126",
      "E126",
      "Roses Ice",
      "Roses"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "grün"
    ],
    "directionTerms": [
      "frisch",
      "grün"
    ],
    "directProductTerms": [
      "E-126 - Roses Ice",
      "E-126",
      "E126",
      "e-126-roses-ice"
    ],
    "shopHandle": "e-126-roses-ice",
    "handle": "e-126-roses-ice",
    "shopCode": "E-126",
    "shopProduct": "E-126 - Roses Ice",
    "productUrl": "https://dieduftquelle.com/products/e-126-roses-ice",
    "confidence": 100,
    "direction": "frisch - grün",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "montale-lucky-candy",
    "brand": "Montale",
    "name": "Lucky Candy",
    "variant": "",
    "searchTerms": [
      "Lucky Candy",
      "Montale Lucky Candy",
      "E-130 - Candy Luck",
      "E-130",
      "E130",
      "Candy Luck",
      "Lucky",
      "Candy"
    ],
    "notes": [],
    "accords": [
      "süß",
      "blumig"
    ],
    "directionTerms": [
      "süß",
      "blumig"
    ],
    "directProductTerms": [
      "E-130 - Candy Luck",
      "E-130",
      "E130",
      "e-130-lucky-candy"
    ],
    "shopHandle": "e-130-lucky-candy",
    "handle": "e-130-lucky-candy",
    "shopCode": "E-130",
    "shopProduct": "E-130 - Candy Luck",
    "productUrl": "https://dieduftquelle.com/products/e-130-lucky-candy",
    "confidence": 100,
    "direction": "süß - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "narciso-rodriguez-vetiver-musc",
    "brand": "Narciso Rodriguez",
    "name": "Vetiver Musc",
    "variant": "",
    "searchTerms": [
      "Vetiver Musc",
      "Narciso Rodriguez Vetiver Musc",
      "E-132 - Vetiver Musk",
      "E-132",
      "E132",
      "NR Vetiver Musc",
      "Vetiver Musk",
      "Vetiver"
    ],
    "notes": [
      "Kardamon",
      "Muskat",
      "Zypresse",
      "Moschus",
      "Rosengeranie",
      "Rotalge",
      "Lavendel",
      "Vetiver",
      "Zedernholz",
      "Patchouli"
    ],
    "accords": [
      "grün",
      "frisch"
    ],
    "directionTerms": [
      "grün",
      "frisch"
    ],
    "directProductTerms": [
      "E-132 - Vetiver Musk",
      "E-132",
      "E132",
      "e-132-vetiver-musk"
    ],
    "shopHandle": "e-132-vetiver-musk",
    "handle": "e-132-vetiver-musk",
    "shopCode": "E-132",
    "shopProduct": "E-132 - Vetiver Musk",
    "productUrl": "https://dieduftquelle.com/products/e-132-vetiver-musk",
    "confidence": 100,
    "direction": "grün - frisch",
    "topNotes": "Kardamon, Muskat, Zypresse",
    "heartNotes": "Moschus, Rosengeranie, Rotalge, Lavendel",
    "baseNotes": "Vetiver, Zedernholz, Patchouli"
  },
  {
    "id": "ex-nihilo-fleur-narcotique",
    "brand": "Ex Nihilo",
    "name": "Fleur Narcotique",
    "variant": "",
    "searchTerms": [
      "Fleur Narcotique",
      "Ex Nihilo Fleur Narcotique",
      "E-15 - Narcotique Bloom",
      "E-15",
      "E15",
      "Narcotique Bloom",
      "Fleur",
      "Narcotique"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "fruchtig"
    ],
    "directionTerms": [
      "blumig",
      "fruchtig"
    ],
    "directProductTerms": [
      "E-15 - Narcotique Bloom",
      "E-15",
      "E15",
      "e-15-narcotique-bloom"
    ],
    "shopHandle": "e-15-narcotique-bloom",
    "handle": "e-15-narcotique-bloom",
    "shopCode": "E-15",
    "shopProduct": "E-15 - Narcotique Bloom",
    "productUrl": "https://dieduftquelle.com/products/e-15-narcotique-bloom",
    "confidence": 100,
    "direction": "blumig-fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tiziana-terenzi-kirke",
    "brand": "Tiziana Terenzi",
    "name": "Kirke",
    "variant": "",
    "searchTerms": [
      "Kirke",
      "Tiziana Terenzi Kirke",
      "E-2 - Kirque",
      "E-2",
      "E2",
      "Terenzi Kirke",
      "Kirque"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "süß"
    ],
    "directionTerms": [
      "fruchtig",
      "süß"
    ],
    "directProductTerms": [
      "E-2 - Kirque",
      "E-2",
      "E2",
      "kirque"
    ],
    "shopHandle": "kirque",
    "handle": "kirque",
    "shopCode": "E-2",
    "shopProduct": "E-2 - Kirque",
    "productUrl": "https://dieduftquelle.com/products/kirque",
    "confidence": 100,
    "direction": "fruchtig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "roja-oligarch",
    "brand": "Roja",
    "name": "Oligarch",
    "variant": "",
    "searchTerms": [
      "Oligarch",
      "Roja Oligarch",
      "E-24 - Oliga",
      "E-24",
      "E24",
      "Oliga"
    ],
    "notes": [],
    "accords": [
      "zitrisch",
      "würzig"
    ],
    "directionTerms": [
      "zitrisch",
      "würzig"
    ],
    "directProductTerms": [
      "E-24 - Oliga",
      "E-24",
      "E24",
      "e-24-tycoon"
    ],
    "shopHandle": "e-24-tycoon",
    "handle": "e-24-tycoon",
    "shopCode": "E-24",
    "shopProduct": "E-24 - Oliga",
    "productUrl": "https://dieduftquelle.com/products/e-24-tycoon",
    "confidence": 100,
    "direction": "zitrisch - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "parfums-de-marly-carlisle",
    "brand": "Parfums de Marly",
    "name": "Carlisle",
    "variant": "",
    "searchTerms": [
      "Carlisle",
      "Parfums de Marly Carlisle",
      "E-45 Carli",
      "E-45",
      "E45",
      "PDM Carlisle",
      "Parfum de Marly Carlisle",
      "Carli"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "E-45 Carli",
      "E-45",
      "E45",
      "e-45-carli"
    ],
    "shopHandle": "e-45-carli",
    "handle": "e-45-carli",
    "shopCode": "E-45",
    "shopProduct": "E-45 Carli",
    "productUrl": "https://dieduftquelle.com/products/e-45-carli",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-accento",
    "brand": "Xerjoff",
    "name": "Accento",
    "variant": "",
    "searchTerms": [
      "Accento",
      "Xerjoff Accento",
      "E-47 - Akzent",
      "E-47",
      "E47",
      "XJ Accento",
      "Akzent"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "blumig"
    ],
    "directionTerms": [
      "fruchtig",
      "blumig"
    ],
    "directProductTerms": [
      "E-47 - Akzent",
      "E-47",
      "E47",
      "e-47-akzent"
    ],
    "shopHandle": "e-47-akzent",
    "handle": "e-47-akzent",
    "shopCode": "E-47",
    "shopProduct": "E-47 - Akzent",
    "productUrl": "https://dieduftquelle.com/products/e-47-akzent",
    "confidence": 100,
    "direction": "fruchtig - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "parfums-de-marly-delina",
    "brand": "Parfums de Marly",
    "name": "Delina",
    "variant": "",
    "searchTerms": [
      "Delina",
      "Parfums de Marly Delina",
      "E-63 di Lina",
      "E-63",
      "E63",
      "PDM Delina",
      "Parfum de Marly Delina",
      "di Lina"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "fruchtig"
    ],
    "directionTerms": [
      "blumig",
      "fruchtig"
    ],
    "directProductTerms": [
      "E-63 di Lina",
      "E-63",
      "E63",
      "e-64"
    ],
    "shopHandle": "e-64",
    "handle": "e-64",
    "shopCode": "E-63",
    "shopProduct": "E-63 di Lina",
    "productUrl": "https://dieduftquelle.com/products/e-64",
    "confidence": 100,
    "direction": "blumig - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "byredo-bal-d-afrique",
    "brand": "Byredo",
    "name": "Bal d'Afrique",
    "variant": "",
    "searchTerms": [
      "Bal d'Afrique",
      "Byredo Bal d'Afrique",
      "E-64 - Afrique",
      "E-64",
      "E64",
      "Afrique"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "frisch"
    ],
    "directionTerms": [
      "blumig",
      "frisch"
    ],
    "directProductTerms": [
      "E-64 - Afrique",
      "E-64",
      "E64",
      "e-65"
    ],
    "shopHandle": "e-65",
    "handle": "e-65",
    "shopCode": "E-64",
    "shopProduct": "E-64 - Afrique",
    "productUrl": "https://dieduftquelle.com/products/e-65",
    "confidence": 100,
    "direction": "blumig - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "parfums-de-marly-oriana",
    "brand": "Parfums de Marly",
    "name": "Oriana",
    "variant": "",
    "searchTerms": [
      "Oriana",
      "Parfums de Marly Oriana",
      "E-83 - Oh Riana",
      "E-83",
      "E83",
      "PDM Oriana",
      "Parfum de Marly Oriana",
      "Oh Riana"
    ],
    "notes": [],
    "accords": [
      "süß",
      "fruchtig"
    ],
    "directionTerms": [
      "süß",
      "fruchtig"
    ],
    "directProductTerms": [
      "E-83 - Oh Riana",
      "E-83",
      "E83"
    ],
    "shopHandle": "e-83",
    "handle": "e-83",
    "shopCode": "E-83",
    "shopProduct": "E-83 - Oh Riana",
    "productUrl": "https://dieduftquelle.com/products/e-83",
    "confidence": 100,
    "direction": "süß - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "parfums-de-marly-valaya",
    "brand": "Parfums de Marly",
    "name": "Valaya",
    "variant": "",
    "searchTerms": [
      "Valaya",
      "Parfums de Marly Valaya",
      "E-92 - Vlaya",
      "E-92",
      "E92",
      "PDM Valaya",
      "Parfum de Marly Valaya",
      "Vlaya"
    ],
    "notes": [],
    "accords": [
      "synthetisch",
      "blumig"
    ],
    "directionTerms": [
      "synthetisch",
      "blumig"
    ],
    "directProductTerms": [
      "E-92 - Vlaya",
      "E-92",
      "E92"
    ],
    "shopHandle": "e-92",
    "handle": "e-92",
    "shopCode": "E-92",
    "shopProduct": "E-92 - Vlaya",
    "productUrl": "https://dieduftquelle.com/products/e-92",
    "confidence": 100,
    "direction": "synthetisch - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "mancera-aoud-vanille",
    "brand": "Mancera",
    "name": "Aoud Vanille",
    "variant": "",
    "searchTerms": [
      "Aoud Vanille",
      "Mancera Aoud Vanille",
      "E-97 - A.oud Vanille",
      "E-97",
      "E97",
      "A.oud Vanille",
      "Vanille"
    ],
    "notes": [],
    "accords": [
      "süß",
      "holzig"
    ],
    "directionTerms": [
      "süß",
      "holzig"
    ],
    "directProductTerms": [
      "E-97 - A.oud Vanille",
      "E-97",
      "E97",
      "e-97-a-oud-vanille"
    ],
    "shopHandle": "e-97-a-oud-vanille",
    "handle": "e-97-a-oud-vanille",
    "shopCode": "E-97",
    "shopProduct": "E-97 - A.oud Vanille",
    "productUrl": "https://dieduftquelle.com/products/e-97-a-oud-vanille",
    "confidence": 100,
    "direction": "süß - holzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "profumum-roma-acqua-e-zucchero",
    "brand": "Profumum Roma",
    "name": "Acqua e Zucchero",
    "variant": "",
    "searchTerms": [
      "Acqua e Zucchero",
      "Profumum Roma Acqua e Zucchero",
      "E-99 - Zuchero",
      "E-99",
      "E99",
      "Zuchero",
      "Acqua",
      "Zucchero"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "E-99 - Zuchero",
      "E-99",
      "E99",
      "e-99-alternative-zu-acqua-e-zucchero"
    ],
    "shopHandle": "e-99-alternative-zu-acqua-e-zucchero",
    "handle": "e-99-alternative-zu-acqua-e-zucchero",
    "shopCode": "E-99",
    "shopProduct": "E-99 - Zuchero",
    "productUrl": "https://dieduftquelle.com/products/e-99-alternative-zu-acqua-e-zucchero",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "parfums-de-marly-greenley",
    "brand": "Parfums de Marly",
    "name": "Greenley",
    "variant": "",
    "searchTerms": [
      "Greenley",
      "Parfums de Marly Greenley",
      "Greenie",
      "PDM Greenley",
      "Parfum de Marly Greenley",
      "L-49",
      "L49"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "grün"
    ],
    "directionTerms": [
      "frisch",
      "grün"
    ],
    "directProductTerms": [
      "Greenie",
      "L-49",
      "L49"
    ],
    "shopHandle": "greenie",
    "handle": "greenie",
    "shopCode": "L-49",
    "shopProduct": "Greenie",
    "productUrl": "https://dieduftquelle.com/products/greenie",
    "confidence": 100,
    "direction": "frisch - grün",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "anfas-ishq",
    "brand": "Anfas",
    "name": "Ishq",
    "variant": "",
    "searchTerms": [
      "Ishq",
      "Anfas Ishq",
      "L-1 - Ischque",
      "L-1",
      "L1",
      "Ischque"
    ],
    "notes": [],
    "accords": [
      "süß",
      "fruchtig"
    ],
    "directionTerms": [
      "süß",
      "fruchtig"
    ],
    "directProductTerms": [
      "L-1 - Ischque",
      "L-1",
      "L1",
      "ishq-duft"
    ],
    "shopHandle": "ishq-duft",
    "handle": "ishq-duft",
    "shopCode": "L-1",
    "shopProduct": "L-1 - Ischque",
    "productUrl": "https://dieduftquelle.com/products/ishq-duft",
    "confidence": 100,
    "direction": "süß - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "maison-crivelli-oud-maracuja",
    "brand": "Maison Crivelli",
    "name": "Oud Maracujá",
    "variant": "",
    "searchTerms": [
      "Oud Maracujá",
      "Maison Crivelli Oud Maracujá",
      "L-12 - O. Maracuja",
      "L-12",
      "L12",
      "Oud Maracuja",
      "Maison Crivelli Oud Maracuja",
      "O. Maracuja",
      "Maracujá"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "ledrig"
    ],
    "directionTerms": [
      "fruchtig",
      "ledrig"
    ],
    "directProductTerms": [
      "L-12 - O. Maracuja",
      "L-12",
      "L12",
      "l-12-o-maracuja"
    ],
    "shopHandle": "l-12-o-maracuja",
    "handle": "l-12-o-maracuja",
    "shopCode": "L-12",
    "shopProduct": "L-12 - O. Maracuja",
    "productUrl": "https://dieduftquelle.com/products/l-12-o-maracuja",
    "confidence": 100,
    "direction": "fruchtig - ledrig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "byredo-mojave-ghost",
    "brand": "Byredo",
    "name": "Mojave Ghost",
    "variant": "",
    "searchTerms": [
      "Mojave Ghost",
      "Byredo Mojave Ghost",
      "L-18 - M. Ghost",
      "L-18",
      "L18",
      "M. Ghost",
      "Mojave",
      "Ghost"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "frisch"
    ],
    "directionTerms": [
      "blumig",
      "frisch"
    ],
    "directProductTerms": [
      "L-18 - M. Ghost",
      "L-18",
      "L18",
      "l-18-m-ghost"
    ],
    "shopHandle": "l-18-m-ghost",
    "handle": "l-18-m-ghost",
    "shopCode": "L-18",
    "shopProduct": "L-18 - M. Ghost",
    "productUrl": "https://dieduftquelle.com/products/l-18-m-ghost",
    "confidence": 100,
    "direction": "blumig - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "stephane-humbert-lucas-god-of-fire",
    "brand": "Stéphane Humbert Lucas",
    "name": "God of Fire",
    "variant": "",
    "searchTerms": [
      "God of Fire",
      "Stéphane Humbert Lucas God of Fire",
      "L-23 - Goat of Fire",
      "L-23",
      "L23",
      "SHL God of Fire",
      "Stephane Humbert Lucas God of Fire",
      "Goat of Fire"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "süß"
    ],
    "directionTerms": [
      "fruchtig",
      "süß"
    ],
    "directProductTerms": [
      "L-23 - Goat of Fire",
      "L-23",
      "L23",
      "l-23-goat-of-fire"
    ],
    "shopHandle": "l-23-goat-of-fire",
    "handle": "l-23-goat-of-fire",
    "shopCode": "L-23",
    "shopProduct": "L-23 - Goat of Fire",
    "productUrl": "https://dieduftquelle.com/products/l-23-goat-of-fire",
    "confidence": 100,
    "direction": "fruchtig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "mancera-french-riviera",
    "brand": "Mancera",
    "name": "French Riviera",
    "variant": "",
    "searchTerms": [
      "French Riviera",
      "Mancera French Riviera",
      "L-24 - French Rivera",
      "L-24",
      "L24",
      "French Rivera",
      "French",
      "Riviera"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "aquatisch"
    ],
    "directionTerms": [
      "frisch",
      "aquatisch"
    ],
    "directProductTerms": [
      "L-24 - French Rivera",
      "L-24",
      "L24",
      "french-rivera"
    ],
    "shopHandle": "french-rivera",
    "handle": "french-rivera",
    "shopCode": "L-24",
    "shopProduct": "L-24 - French Rivera",
    "productUrl": "https://dieduftquelle.com/products/french-rivera",
    "confidence": 100,
    "direction": "frisch - aquatisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-ombre-leather",
    "brand": "Tom Ford",
    "name": "Ombré Leather",
    "variant": "",
    "searchTerms": [
      "Ombré Leather",
      "Tom Ford Ombré Leather",
      "L-27 - O.Leather",
      "L-27",
      "L27",
      "TF Ombré Leather",
      "Ombre Leather",
      "Tom Ford Ombre Leather",
      "TF Ombre Leather",
      "O.Leather",
      "Ombré",
      "Leather"
    ],
    "notes": [],
    "accords": [
      "ledrig",
      "würzig"
    ],
    "directionTerms": [
      "ledrig",
      "würzig"
    ],
    "directProductTerms": [
      "L-27 - O.Leather",
      "L-27",
      "L27",
      "l-27-o-leather"
    ],
    "shopHandle": "l-27-o-leather",
    "handle": "l-27-o-leather",
    "shopCode": "L-27",
    "shopProduct": "L-27 - O.Leather",
    "productUrl": "https://dieduftquelle.com/products/l-27-o-leather",
    "confidence": 100,
    "direction": "ledrig - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "burberry-goddess",
    "brand": "Burberry",
    "name": "Goddess",
    "variant": "",
    "searchTerms": [
      "Goddess",
      "Burberry Goddess",
      "L-28 - Goddest",
      "L-28",
      "L28",
      "Goddest"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "L-28 - Goddest",
      "L-28",
      "L28",
      "l-28-godde"
    ],
    "shopHandle": "l-28-godde",
    "handle": "l-28-godde",
    "shopCode": "L-28",
    "shopProduct": "L-28 - Goddest",
    "productUrl": "https://dieduftquelle.com/products/l-28-godde",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "maison-margiela-beach-walk",
    "brand": "Maison Margiela",
    "name": "Beach Walk",
    "variant": "",
    "searchTerms": [
      "Beach Walk",
      "Maison Margiela Beach Walk",
      "L-29 - Walk Beach",
      "L-29",
      "L29",
      "Margiela Beach Walk",
      "Replica Beach Walk",
      "Walk Beach",
      "Beach"
    ],
    "notes": [],
    "accords": [
      "cremig",
      "süß"
    ],
    "directionTerms": [
      "cremig",
      "süß"
    ],
    "directProductTerms": [
      "L-29 - Walk Beach",
      "L-29",
      "L29",
      "l-29-walk-beach"
    ],
    "shopHandle": "l-29-walk-beach",
    "handle": "l-29-walk-beach",
    "shopCode": "L-29",
    "shopProduct": "L-29 - Walk Beach",
    "productUrl": "https://dieduftquelle.com/products/l-29-walk-beach",
    "confidence": 100,
    "direction": "cremig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "mancera-aoud-lemon-mint",
    "brand": "Mancera",
    "name": "Aoud Lemon Mint",
    "variant": "",
    "searchTerms": [
      "Aoud Lemon Mint",
      "Mancera Aoud Lemon Mint",
      "L-4 - A. Mint Lemon",
      "L-4",
      "L4",
      "A. Mint Lemon",
      "Lemon"
    ],
    "notes": [],
    "accords": [
      "zitrisch",
      "frisch"
    ],
    "directionTerms": [
      "zitrisch",
      "frisch"
    ],
    "directProductTerms": [
      "L-4 - A. Mint Lemon",
      "L-4",
      "L4",
      "l-4-lemon-mint"
    ],
    "shopHandle": "l-4-lemon-mint",
    "handle": "l-4-lemon-mint",
    "shopCode": "L-4",
    "shopProduct": "L-4 - A. Mint Lemon",
    "productUrl": "https://dieduftquelle.com/products/l-4-lemon-mint",
    "confidence": 100,
    "direction": "zitrisch - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dieduftquelle-silky-muse",
    "brand": "DieDuftQuelle",
    "name": "Silky Muse",
    "variant": "",
    "searchTerms": [
      "Silky Muse",
      "DieDuftQuelle Silky Muse",
      "L-41 - Silky Muse",
      "L-41",
      "L41",
      "Silky"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "pudrig"
    ],
    "directionTerms": [
      "frisch",
      "pudrig"
    ],
    "directProductTerms": [
      "L-41 - Silky Muse",
      "L-41",
      "L41",
      "l-41-silky-muse"
    ],
    "shopHandle": "l-41-silky-muse",
    "handle": "l-41-silky-muse",
    "shopCode": "L-41",
    "shopProduct": "L-41 - Silky Muse",
    "productUrl": "https://dieduftquelle.com/products/l-41-silky-muse",
    "confidence": 100,
    "direction": "frisch - pudrig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dieduftquelle-rouge-de-muse",
    "brand": "DieDuftQuelle",
    "name": "Rouge de Muse",
    "variant": "",
    "searchTerms": [
      "Rouge de Muse",
      "DieDuftQuelle Rouge de Muse",
      "L-44 - Rouge de Muse",
      "L-44",
      "L44",
      "Rouge"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "würzig"
    ],
    "directionTerms": [
      "frisch",
      "würzig"
    ],
    "directProductTerms": [
      "L-44 - Rouge de Muse",
      "L-44",
      "L44",
      "l-44-rouge-de-muse"
    ],
    "shopHandle": "l-44-rouge-de-muse",
    "handle": "l-44-rouge-de-muse",
    "shopCode": "L-44",
    "shopProduct": "L-44 - Rouge de Muse",
    "productUrl": "https://dieduftquelle.com/products/l-44-rouge-de-muse",
    "confidence": 100,
    "direction": "frisch - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "issey-miyake-le-sel-d-issey",
    "brand": "Issey Miyake",
    "name": "Le Sel d'Issey",
    "variant": "",
    "searchTerms": [
      "Le Sel d'Issey",
      "Issey Miyake Le Sel d'Issey",
      "Le Sel",
      "L-46 Le Sel",
      "L-46",
      "L46"
    ],
    "notes": [],
    "accords": [
      "aquatisch",
      "frisch"
    ],
    "directionTerms": [
      "aquatisch",
      "frisch"
    ],
    "directProductTerms": [
      "L-46 Le Sel",
      "L-46",
      "L46",
      "l-45-le-sel"
    ],
    "shopHandle": "l-45-le-sel",
    "handle": "l-45-le-sel",
    "shopCode": "L-46",
    "shopProduct": "L-46 Le Sel",
    "productUrl": "https://dieduftquelle.com/products/l-45-le-sel",
    "confidence": 100,
    "direction": "aquatisch - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "bvlgari-tygar",
    "brand": "Bvlgari",
    "name": "Tygar",
    "variant": "",
    "searchTerms": [
      "Tygar",
      "Bvlgari Tygar",
      "L-48 - Tiger",
      "L-48",
      "L48",
      "Bulgari Tygar",
      "Tiger"
    ],
    "notes": [],
    "accords": [
      "zitrisch",
      "frisch"
    ],
    "directionTerms": [
      "zitrisch",
      "frisch"
    ],
    "directProductTerms": [
      "L-48 - Tiger",
      "L-48",
      "L48",
      "l-48-tiger"
    ],
    "shopHandle": "l-48-tiger",
    "handle": "l-48-tiger",
    "shopCode": "L-48",
    "shopProduct": "L-48 - Tiger",
    "productUrl": "https://dieduftquelle.com/products/l-48-tiger",
    "confidence": 100,
    "direction": "zitrisch - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kayali-vanilla-28",
    "brand": "Kayali",
    "name": "Vanilla 28",
    "variant": "",
    "searchTerms": [
      "Vanilla 28",
      "Kayali Vanilla 28",
      "L-5 - Vanilla 2.8",
      "L-5",
      "L5",
      "Vanilla 2.8",
      "Vanilla"
    ],
    "notes": [],
    "accords": [
      "süß",
      "Gourmand"
    ],
    "directionTerms": [
      "süß",
      "Gourmand"
    ],
    "directProductTerms": [
      "L-5 - Vanilla 2.8",
      "L-5",
      "L5",
      "l-5-vanilla"
    ],
    "shopHandle": "l-5-vanilla",
    "handle": "l-5-vanilla",
    "shopCode": "L-5",
    "shopProduct": "L-5 - Vanilla 2.8",
    "productUrl": "https://dieduftquelle.com/products/l-5-vanilla",
    "confidence": 100,
    "direction": "süß - Gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "louis-vuitton-rainy",
    "brand": "Louis Vuitton",
    "name": "Rainy",
    "variant": "",
    "searchTerms": [
      "Rainy",
      "Louis Vuitton Rainy",
      "L-51 - Raining Tee",
      "L-51",
      "L51",
      "LV Rainy",
      "Raining Tee"
    ],
    "notes": [],
    "accords": [
      "grün",
      "blumig"
    ],
    "directionTerms": [
      "grün",
      "blumig"
    ],
    "directProductTerms": [
      "L-51 - Raining Tee",
      "L-51",
      "L51",
      "l-51-raining"
    ],
    "shopHandle": "l-51-raining",
    "handle": "l-51-raining",
    "shopCode": "L-51",
    "shopProduct": "L-51 - Raining Tee",
    "productUrl": "https://dieduftquelle.com/products/l-51-raining",
    "confidence": 100,
    "direction": "grün - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "louis-vuitton-incense-mark",
    "brand": "Louis Vuitton",
    "name": "Incense Mark",
    "variant": "",
    "searchTerms": [
      "Incense Mark",
      "Louis Vuitton Incense Mark",
      "L-52 - Inking",
      "L-52",
      "L52",
      "LV Incense Mark",
      "Inking",
      "Incense"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "pudrig"
    ],
    "directionTerms": [
      "holzig",
      "pudrig"
    ],
    "directProductTerms": [
      "L-52 - Inking",
      "L-52",
      "L52",
      "l-52-inking"
    ],
    "shopHandle": "l-52-inking",
    "handle": "l-52-inking",
    "shopCode": "L-52",
    "shopProduct": "L-52 - Inking",
    "productUrl": "https://dieduftquelle.com/products/l-52-inking",
    "confidence": 100,
    "direction": "holzig - pudrig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "lancome-la-nuit-tresor",
    "brand": "Lancôme",
    "name": "La Nuit Trésor",
    "variant": "",
    "searchTerms": [
      "La Nuit Trésor",
      "La Nuit Tresor",
      "Lancôme La Nuit Trésor",
      "Lancome La Nuit Tresor",
      "La Nuite Women",
      "W-19",
      "W19"
    ],
    "notes": [],
    "accords": [
      "süß",
      "gourmand"
    ],
    "directionTerms": [
      "süß",
      "gourmand"
    ],
    "directProductTerms": [
      "La Nuite Women",
      "W-19",
      "W19",
      "w-19-la-nuite"
    ],
    "shopHandle": "w-19-la-nuite",
    "handle": "w-19-la-nuite",
    "shopCode": "W-19",
    "shopProduct": "La Nuite Women",
    "productUrl": "https://dieduftquelle.com/products/w-19-la-nuite",
    "confidence": 100,
    "direction": "süß - gourmand",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dior-ambre-nuit",
    "brand": "Dior",
    "name": "Ambre Nuit",
    "variant": "",
    "searchTerms": [
      "Ambre Nuit",
      "Dior Ambre Nuit",
      "M-39 - Nuit Amber",
      "M-39",
      "M39",
      "Nuit Amber",
      "Ambre"
    ],
    "notes": [],
    "accords": [
      "holzig",
      "süß"
    ],
    "directionTerms": [
      "holzig",
      "süß"
    ],
    "directProductTerms": [
      "M-39 - Nuit Amber",
      "M-39",
      "M39",
      "m-39-d-ambre-nuit"
    ],
    "shopHandle": "m-39-d-ambre-nuit",
    "handle": "m-39-d-ambre-nuit",
    "shopCode": "M-39",
    "shopProduct": "M-39 - Nuit Amber",
    "productUrl": "https://dieduftquelle.com/products/m-39-d-ambre-nuit",
    "confidence": 100,
    "direction": "holzig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-lira",
    "brand": "Xerjoff",
    "name": "Lira",
    "variant": "",
    "searchTerms": [
      "Lira",
      "Xerjoff Lira",
      "M-4 - Lira",
      "M-4",
      "M4",
      "XJ Lira"
    ],
    "notes": [],
    "accords": [
      "gourmand",
      "Süß"
    ],
    "directionTerms": [
      "gourmand",
      "Süß"
    ],
    "directProductTerms": [
      "M-4 - Lira",
      "M-4",
      "M4",
      "m-4-lira"
    ],
    "shopHandle": "m-4-lira",
    "handle": "m-4-lira",
    "shopCode": "M-4",
    "shopProduct": "M-4 - Lira",
    "productUrl": "https://dieduftquelle.com/products/m-4-lira",
    "confidence": 100,
    "direction": "gourmand - Süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kilian-black-phantom",
    "brand": "Kilian",
    "name": "Black Phantom",
    "variant": "",
    "searchTerms": [
      "Black Phantom",
      "Kilian Black Phantom",
      "M-57 Bl. Phantom",
      "M-57",
      "M57",
      "Bl. Phantom",
      "Black",
      "Phantom"
    ],
    "notes": [],
    "accords": [
      "gourmand",
      "süß"
    ],
    "directionTerms": [
      "gourmand",
      "süß"
    ],
    "directProductTerms": [
      "M-57 Bl. Phantom",
      "M-57",
      "M57"
    ],
    "shopHandle": "m-57",
    "handle": "m-57",
    "shopCode": "M-57",
    "shopProduct": "M-57 Bl. Phantom",
    "productUrl": "https://dieduftquelle.com/products/m-57",
    "confidence": 100,
    "direction": "gourmand - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "prada-luna-rossa-black",
    "brand": "Prada",
    "name": "Luna Rossa Black",
    "variant": "",
    "searchTerms": [
      "Luna Rossa Black",
      "Prada Luna Rossa Black",
      "M-6 - Rossa Black",
      "M-6",
      "M6",
      "Rossa Black",
      "Rossa",
      "Black"
    ],
    "notes": [],
    "accords": [
      "süß",
      "pudrig"
    ],
    "directionTerms": [
      "süß",
      "pudrig"
    ],
    "directProductTerms": [
      "M-6 - Rossa Black",
      "M-6",
      "M6",
      "m-7-rossa-black"
    ],
    "shopHandle": "m-7-rossa-black",
    "handle": "m-7-rossa-black",
    "shopCode": "M-6",
    "shopProduct": "M-6 - Rossa Black",
    "productUrl": "https://dieduftquelle.com/products/m-7-rossa-black",
    "confidence": 100,
    "direction": "süß - pudrig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "jean-paul-gaultier-le-male",
    "brand": "Jean Paul Gaultier",
    "name": "Le Male",
    "variant": "",
    "searchTerms": [
      "Le Male",
      "Jean Paul Gaultier Le Male",
      "M-9 - Male",
      "M-9",
      "M9",
      "JPG Le Male",
      "Male"
    ],
    "notes": [],
    "accords": [
      "süß",
      "würzig"
    ],
    "directionTerms": [
      "süß",
      "würzig"
    ],
    "directProductTerms": [
      "M-9 - Male",
      "M-9",
      "M9",
      "m-9-male"
    ],
    "shopHandle": "m-9-male",
    "handle": "m-9-male",
    "shopCode": "M-9",
    "shopProduct": "M-9 - Male",
    "productUrl": "https://dieduftquelle.com/products/m-9-male",
    "confidence": 100,
    "direction": "süß - würzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "maison-crivelli-hibiscus-mahajad",
    "brand": "Maison Crivelli",
    "name": "Hibiscus Mahajád",
    "variant": "",
    "searchTerms": [
      "Hibiscus Mahajád",
      "Maison Crivelli Hibiscus Mahajád",
      "Mahacat",
      "Hibiscus Mahajad",
      "Maison Crivelli Hibiscus Mahajad",
      "Hibiscus",
      "Mahajád",
      "L-42",
      "L42"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "süß"
    ],
    "directionTerms": [
      "blumig",
      "süß"
    ],
    "directProductTerms": [
      "Mahacat",
      "L-42",
      "L42",
      "mahajad"
    ],
    "shopHandle": "mahajad",
    "handle": "mahajad",
    "shopCode": "L-42",
    "shopProduct": "Mahacat",
    "productUrl": "https://dieduftquelle.com/products/mahajad",
    "confidence": 100,
    "direction": "blumig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "zarkoperfume-the-muse",
    "brand": "ZARKOPERFUME",
    "name": "The Muse",
    "variant": "",
    "searchTerms": [
      "The Muse",
      "ZARKOPERFUME The Muse",
      "Muse",
      "Zarko Parfum The Muse",
      "L-35",
      "L35"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "syntetisch"
    ],
    "directionTerms": [
      "frisch",
      "syntetisch"
    ],
    "directProductTerms": [
      "Muse",
      "L-35",
      "L35",
      "l-35-the-muse"
    ],
    "shopHandle": "l-35-the-muse",
    "handle": "l-35-the-muse",
    "shopCode": "L-35",
    "shopProduct": "Muse",
    "productUrl": "https://dieduftquelle.com/products/l-35-the-muse",
    "confidence": 100,
    "direction": "frisch - syntetisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "yves-saint-laurent-myslf",
    "brand": "Yves Saint Laurent",
    "name": "MYSLF",
    "variant": "",
    "searchTerms": [
      "MYSLF",
      "Yves Saint Laurent MYSLF",
      "My Self",
      "YSL MYSLF",
      "Saint Laurent MYSLF",
      "Myself",
      "YSL Myself",
      "L-21",
      "L21"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "synthetisch"
    ],
    "directionTerms": [
      "frisch",
      "synthetisch"
    ],
    "directProductTerms": [
      "My Self",
      "L-21",
      "L21",
      "l-21-my-self"
    ],
    "shopHandle": "l-21-my-self",
    "handle": "l-21-my-self",
    "shopCode": "L-21",
    "shopProduct": "My Self",
    "productUrl": "https://dieduftquelle.com/products/l-21-my-self",
    "confidence": 100,
    "direction": "frisch - synthetisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "xerjoff-opera",
    "brand": "Xerjoff",
    "name": "Opera",
    "variant": "",
    "searchTerms": [
      "Opera",
      "Xerjoff Opera",
      "XJ Opera",
      "E-91",
      "E91"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "fruchtig"
    ],
    "directionTerms": [
      "blumig",
      "fruchtig"
    ],
    "directProductTerms": [
      "Opera",
      "E-91",
      "E91",
      "e-91-opera"
    ],
    "shopHandle": "e-91-opera",
    "handle": "e-91-opera",
    "shopCode": "E-91",
    "shopProduct": "Opera",
    "productUrl": "https://dieduftquelle.com/products/e-91-opera",
    "confidence": 100,
    "direction": "blumig - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "yves-saint-laurent-black-opium-over-red",
    "brand": "Yves Saint Laurent",
    "name": "Black Opium Over Red",
    "variant": "",
    "searchTerms": [
      "Black Opium Over Red",
      "Yves Saint Laurent Black Opium Over Red",
      "Opyom O. Red",
      "YSL Black Opium Over Red",
      "Saint Laurent Black Opium Over Red",
      "Black",
      "Opium",
      "W-59",
      "W59"
    ],
    "notes": [],
    "accords": [
      "süß",
      "fruchtig"
    ],
    "directionTerms": [
      "süß",
      "fruchtig"
    ],
    "directProductTerms": [
      "Opyom O. Red",
      "W-59",
      "W59",
      "w-59-opium-over-red"
    ],
    "shopHandle": "w-59-opium-over-red",
    "handle": "w-59-opium-over-red",
    "shopCode": "W-59",
    "shopProduct": "Opyom O. Red",
    "productUrl": "https://dieduftquelle.com/products/w-59-opium-over-red",
    "confidence": 100,
    "direction": "süß - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dieduftquelle-pinepear-accento-kirke",
    "brand": "DieDuftQuelle",
    "name": "PinePear – Accento × Kirke",
    "variant": "",
    "searchTerms": [
      "PinePear – Accento × Kirke",
      "DieDuftQuelle PinePear – Accento × Kirke",
      "PinePear",
      "Accento",
      "Kirke",
      "E-50",
      "E50"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "blumig"
    ],
    "directionTerms": [
      "fruchtig",
      "blumig"
    ],
    "directProductTerms": [
      "PinePear",
      "E-50",
      "E50",
      "pinepear-by-ddq"
    ],
    "shopHandle": "pinepear-by-ddq",
    "handle": "pinepear-by-ddq",
    "shopCode": "E-50",
    "shopProduct": "PinePear",
    "productUrl": "https://dieduftquelle.com/products/pinepear-by-ddq",
    "confidence": 100,
    "direction": "fruchtig - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "kilian-playing-with-the-devil",
    "brand": "Kilian",
    "name": "Playing with the Devil",
    "variant": "",
    "searchTerms": [
      "Playing with the Devil",
      "Kilian Playing with the Devil",
      "Play Devil",
      "Playing",
      "Devil",
      "W-27",
      "W27"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "blumig"
    ],
    "directionTerms": [
      "fruchtig",
      "blumig"
    ],
    "directProductTerms": [
      "Play Devil",
      "W-27",
      "W27",
      "w-28-god-girl-g-bad"
    ],
    "shopHandle": "w-28-god-girl-g-bad",
    "handle": "w-28-god-girl-g-bad",
    "shopCode": "W-27",
    "shopProduct": "Play Devil",
    "productUrl": "https://dieduftquelle.com/products/w-28-god-girl-g-bad",
    "confidence": 100,
    "direction": "fruchtig - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-soleil-blanc",
    "brand": "Tom Ford",
    "name": "Soleil Blanc",
    "variant": "",
    "searchTerms": [
      "Soleil Blanc",
      "Tom Ford Soleil Blanc",
      "S. Blanc",
      "TF Soleil Blanc",
      "Soleil",
      "Blanc",
      "M-51",
      "M51"
    ],
    "notes": [],
    "accords": [
      "cremig",
      "süß"
    ],
    "directionTerms": [
      "cremig",
      "süß"
    ],
    "directProductTerms": [
      "S. Blanc",
      "M-51",
      "M51",
      "m-51-s-blanc"
    ],
    "shopHandle": "m-51-s-blanc",
    "handle": "m-51-s-blanc",
    "shopCode": "M-51",
    "shopProduct": "S. Blanc",
    "productUrl": "https://dieduftquelle.com/products/m-51-s-blanc",
    "confidence": 100,
    "direction": "cremig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "dieduftquelle-soleil-mystique",
    "brand": "DieDuftQuelle",
    "name": "Soleil Mystique",
    "variant": "",
    "searchTerms": [
      "Soleil Mystique",
      "DieDuftQuelle Soleil Mystique",
      "Soleil",
      "Mystique",
      "E-121",
      "E121"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "holzig"
    ],
    "directionTerms": [
      "blumig",
      "holzig"
    ],
    "directProductTerms": [
      "Soleil Mystique",
      "E-121",
      "E121",
      "soleil-mystique"
    ],
    "shopHandle": "soleil-mystique",
    "handle": "soleil-mystique",
    "shopCode": "E-121",
    "shopProduct": "Soleil Mystique",
    "productUrl": "https://dieduftquelle.com/products/soleil-mystique",
    "confidence": 100,
    "direction": "blumig - holzig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "jo-malone-myrrh-tonka",
    "brand": "Jo Malone",
    "name": "Myrrh & Tonka",
    "variant": "",
    "searchTerms": [
      "Myrrh & Tonka",
      "Jo Malone Myrrh & Tonka",
      "Tonka Myrrh",
      "Myrrh",
      "Tonka",
      "L-10",
      "L10"
    ],
    "notes": [],
    "accords": [
      "würzig",
      "süß"
    ],
    "directionTerms": [
      "würzig",
      "süß"
    ],
    "directProductTerms": [
      "Tonka Myrrh",
      "L-10",
      "L10",
      "l-10-tonka-myrrh"
    ],
    "shopHandle": "l-10-tonka-myrrh",
    "handle": "l-10-tonka-myrrh",
    "shopCode": "L-10",
    "shopProduct": "Tonka Myrrh",
    "productUrl": "https://dieduftquelle.com/products/l-10-tonka-myrrh",
    "confidence": 100,
    "direction": "würzig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "montale-soleil-di-capri",
    "brand": "Montale",
    "name": "Soleil di Capri",
    "variant": "",
    "searchTerms": [
      "Soleil di Capri",
      "Montale Soleil di Capri",
      "U-2 - di Carpi",
      "U-2",
      "U2",
      "di Carpi",
      "Soleil",
      "Capri"
    ],
    "notes": [],
    "accords": [
      "zitrisch",
      "frisch"
    ],
    "directionTerms": [
      "zitrisch",
      "frisch"
    ],
    "directProductTerms": [
      "U-2 - di Carpi",
      "U-2",
      "U2",
      "u-1-soleil-di-carpi"
    ],
    "shopHandle": "u-1-soleil-di-carpi",
    "handle": "u-1-soleil-di-carpi",
    "shopCode": "U-2",
    "shopProduct": "U-2 - di Carpi",
    "productUrl": "https://dieduftquelle.com/products/u-1-soleil-di-carpi",
    "confidence": 100,
    "direction": "zitrisch - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "louis-vuitton-imagination",
    "brand": "Louis Vuitton",
    "name": "Imagination",
    "variant": "",
    "searchTerms": [
      "Imagination",
      "Louis Vuitton Imagination",
      "Vision of BlackTea",
      "LV Imagination",
      "Vision of Black Tea",
      "E-57",
      "E57"
    ],
    "notes": [],
    "accords": [
      "zitrisch",
      "frisch"
    ],
    "directionTerms": [
      "zitrisch",
      "frisch"
    ],
    "directProductTerms": [
      "Vision of BlackTea",
      "E-57",
      "E57",
      "vision-of-blacktea"
    ],
    "shopHandle": "vision-of-blacktea",
    "handle": "vision-of-blacktea",
    "shopCode": "E-57",
    "shopProduct": "Vision of BlackTea",
    "productUrl": "https://dieduftquelle.com/products/vision-of-blacktea",
    "confidence": 100,
    "direction": "zitrisch - frisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "mugler-alien",
    "brand": "Mugler",
    "name": "Alien",
    "variant": "",
    "searchTerms": [
      "Alien",
      "Mugler Alien",
      "W-3 - Eliyen",
      "W-3",
      "W3",
      "Thierry Mugler Alien",
      "Eliyen"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "süß"
    ],
    "directionTerms": [
      "blumig",
      "süß"
    ],
    "directProductTerms": [
      "W-3 - Eliyen",
      "W-3",
      "W3",
      "w-3-eliyen"
    ],
    "shopHandle": "w-3-eliyen",
    "handle": "w-3-eliyen",
    "shopCode": "W-3",
    "shopProduct": "W-3 - Eliyen",
    "productUrl": "https://dieduftquelle.com/products/w-3-eliyen",
    "confidence": 100,
    "direction": "blumig - süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "tom-ford-white-musk",
    "brand": "Tom Ford",
    "name": "White Musk",
    "variant": "",
    "searchTerms": [
      "White Musk",
      "Tom Ford White Musk",
      "W-41 - White Musk",
      "W-41",
      "W41",
      "TF White Musk",
      "White"
    ],
    "notes": [],
    "accords": [
      "pudrig",
      "blumig"
    ],
    "directionTerms": [
      "pudrig",
      "blumig"
    ],
    "directProductTerms": [
      "W-41 - White Musk",
      "W-41",
      "W41",
      "w-41-white-musk"
    ],
    "shopHandle": "w-41-white-musk",
    "handle": "w-41-white-musk",
    "shopCode": "W-41",
    "shopProduct": "W-41 - White Musk",
    "productUrl": "https://dieduftquelle.com/products/w-41-white-musk",
    "confidence": 100,
    "direction": "pudrig - blumig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "hugo-boss-the-scent-for-her",
    "brand": "Hugo Boss",
    "name": "The Scent for Her",
    "variant": "",
    "searchTerms": [
      "The Scent for Her",
      "Hugo Boss The Scent for Her",
      "W-63 - Scent Women",
      "W-63",
      "W63",
      "Boss The Scent Woman",
      "The Scent Woman",
      "Scent Women",
      "Scent"
    ],
    "notes": [],
    "accords": [
      "fruchtig",
      "süß"
    ],
    "directionTerms": [
      "fruchtig",
      "süß"
    ],
    "directProductTerms": [
      "W-63 - Scent Women",
      "W-63",
      "W63",
      "w-63-scent-women"
    ],
    "shopHandle": "w-63-scent-women",
    "handle": "w-63-scent-women",
    "shopCode": "W-63",
    "shopProduct": "W-63 - Scent Women",
    "productUrl": "https://dieduftquelle.com/products/w-63-scent-women",
    "confidence": 100,
    "direction": "fruchtig- süß",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "elizabeth-arden-green-tea-coconut-breeze",
    "brand": "Elizabeth Arden",
    "name": "Green Tea Coconut Breeze",
    "variant": "",
    "searchTerms": [
      "Green Tea Coconut Breeze",
      "Elizabeth Arden Green Tea Coconut Breeze",
      "W-64 Green T Coconut",
      "W-64",
      "W64",
      "Green T Coconut",
      "Green",
      "Coconut",
      "Breeze"
    ],
    "notes": [],
    "accords": [
      "frisch",
      "zitrisch"
    ],
    "directionTerms": [
      "frisch",
      "zitrisch"
    ],
    "directProductTerms": [
      "W-64 Green T Coconut",
      "W-64",
      "W64",
      "w-64-green-tea-coconut"
    ],
    "shopHandle": "w-64-green-tea-coconut",
    "handle": "w-64-green-tea-coconut",
    "shopCode": "W-64",
    "shopProduct": "W-64 Green T Coconut",
    "productUrl": "https://dieduftquelle.com/products/w-64-green-tea-coconut",
    "confidence": 100,
    "direction": "frisch - zitrisch",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "creed-carmina",
    "brand": "Creed",
    "name": "Carmina",
    "variant": "",
    "searchTerms": [
      "Carmina",
      "Creed Carmina",
      "W-7 - Carmine",
      "W-7",
      "W7",
      "Carmine"
    ],
    "notes": [],
    "accords": [
      "blumig",
      "fruchtig"
    ],
    "directionTerms": [
      "blumig",
      "fruchtig"
    ],
    "directProductTerms": [
      "W-7 - Carmine",
      "W-7",
      "W7",
      "w-7-carmine"
    ],
    "shopHandle": "w-7-carmine",
    "handle": "w-7-carmine",
    "shopCode": "W-7",
    "shopProduct": "W-7 - Carmine",
    "productUrl": "https://dieduftquelle.com/products/w-7-carmine",
    "confidence": 100,
    "direction": "blumig - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "giorgio-armani-si",
    "brand": "Giorgio Armani",
    "name": "Sì",
    "variant": "",
    "searchTerms": [
      "Sì",
      "Giorgio Armani Sì",
      "W-9 - Siii",
      "W-9",
      "W9",
      "Armani Sì",
      "Si",
      "Giorgio Armani Si",
      "Armani Si",
      "Siii"
    ],
    "notes": [],
    "accords": [
      "süß",
      "fruchtig"
    ],
    "directionTerms": [
      "süß",
      "fruchtig"
    ],
    "directProductTerms": [
      "W-9 - Siii",
      "W-9",
      "W9",
      "w-9-sii"
    ],
    "shopHandle": "w-9-sii",
    "handle": "w-9-sii",
    "shopCode": "W-9",
    "shopProduct": "W-9 - Siii",
    "productUrl": "https://dieduftquelle.com/products/w-9-sii",
    "confidence": 100,
    "direction": "süß - fruchtig",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "louis-vuitton-moon-tale",
    "brand": "Louis Vuitton",
    "name": "Moon Tale",
    "variant": "",
    "searchTerms": [
      "Moon Tale",
      "Louis Vuitton Moon Tale",
      "LV Moon Tale",
      "Moon",
      "L-53 - Moon",
      "L-53",
      "L53"
    ],
    "notes": [],
    "accords": [],
    "directionTerms": [],
    "directProductTerms": [
      "L-53 - Moon",
      "L-53",
      "L53",
      "l-53-moon"
    ],
    "shopHandle": "l-53-moon",
    "handle": "l-53-moon",
    "shopCode": "L-53",
    "shopProduct": "L-53 - Moon",
    "productUrl": "https://dieduftquelle.com/products/l-53-moon",
    "confidence": 100,
    "direction": "",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  },
  {
    "id": "chanel-bleu-de-chanel-l-exclusif",
    "brand": "Chanel",
    "name": "Bleu de Chanel L'Exclusif",
    "variant": "",
    "searchTerms": [
      "Bleu de Chanel L'Exclusif",
      "Chanel Bleu de Chanel L'Exclusif",
      "Bleu L'Exclusif",
      "BDC L'Exclusif",
      "L-47",
      "L47"
    ],
    "notes": [],
    "accords": [],
    "directionTerms": [],
    "directProductTerms": [
      "L-47",
      "L47"
    ],
    "shopHandle": "",
    "handle": "",
    "shopCode": "L-47",
    "shopProduct": "",
    "productUrl": "",
    "confidence": 100,
    "direction": "",
    "topNotes": "",
    "heartNotes": "",
    "baseNotes": ""
  }
];
